import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng, Layer } from 'leaflet';
import { get } from 'http';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { firstValueFrom, take } from 'rxjs';

@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.css']
})
export class AssetListComponent implements OnInit {

  singleObjectInfoData: any = []
  maintenanceScheduleList: any = []
  objectTemplateId = ""

  pageNumber: number = 0;
  page: number = 0;
  recordsPerPage: number = 10;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];


  cid: any
  groupTypeList: any = []
  selectAllChecked: any = false
  isRepairGiven: any = false
  isLock: any = false
  isLockAll: any = false
  isUnLockAll: any = false
  isShowLock: any = false
  objectInfoList: any = []
  objectInfoListWithPagination: any = []
  uomData: any = []
  objectInfoListFilter: any = []
  singleObjectTemplateData: any = []
  proofFile: any = ""
  proofFilePath: any = ""
  proofFileType: any = ""
  objectTemplateList: any = []
  isLoading: any = false
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  icon: any = ""
  branch: any = ""
  branchId: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  objectQty: any = ""
  objectUOM: any = ""
  availableQty: any = ""
  location: any = ""
  objectCondition: any = ""
  assetStatus: any = ""
  givenName: any = ""
  imagesList: any = []
  imagesWithDetails: any = []
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  repairInfoForm: any | FormGroup;
  repairFormSubmit: any = false;
  addAsset: any | FormGroup;
  isMaintenanceSchedule: any = false
  maintenanceList: any = []
  assetMonitoring: any = false
  performance: any = false
  timeSpan: any = ""
  expectedOutput: any = ""
  uom: any = ""
  assetMonitoringFrequency: any = 0
  assetMonitoringTimeSpan: any = 0
  assetHealth: any = false
  connectionsList: any = []
  assetHealthList: any = []
  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  assetConditions = [
    { value: 'Good', label: 'Good' },
    { value: 'UnderRepair', label: 'Under Repair' },
    { value: 'Scrap', label: 'Scrap' }
  ];

  isRepair: any = false
  isRepairDone = false
  userCred: any
  showFilter: any = false
  objectTypeData: any = [];
  objectGroupData: any = [];
  file: any;
  iconFile: any
  largeImage: any = "";
  todayDate: any;
  minEndDate: any;
  currentDate: any;
  editPerformanceMatrix: any = false
  performanceMatrixList: any = [];
  nameValue: any;
  objectColorCode: any = ""
  isObjectColorCode: any = false
  performanceMatrix: any;
  warrantyInfo: any;
  purchaseInfo: any
  acquisitionDate: any = "";
  salvageValue: any;
  depreciationMethod: any;
  // putToUseDate: any = "";
  assetLifeNumber: any;
  asset_Category: any = "";
  objectCategoryList: any = [];
  assetDepreciationDataList: any = [];
  departmentInfoList: any = [];
  searchFilter: any = ""
  tags: any = []
  isClone: any = false
  templateName: any;

  recordName: any = ""
  recordId: any = ""
  parentAssetId: any = 0
  isParentAssetId: any = false
  isNmsAdded: boolean = false;

  private map!: L.Map;
  private map1!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];
  defaultZoom: any = 14
  defaultCenter: L.LatLngExpression = [17.4051564, 78.4927618];
  latlng: any = {
    lat: 0,
    lng: 0
  }
  updatedCoords: any = []
  isLatLng: boolean = false
  objectStatusColor: any = "";
  objectStatus: any = "";

  branchCheckBox: any = false;
  departmentCheckBox: any = false;
  locationCheckBox: any = false;
  makeCheckBox: any = false;
  modelCheckBox: any = false;
  originalCostCheckBox: any = false;
  currentCostCheckBox: any = false;
  serialNumberCheckBox: any = false;
  depreciationCheckbox: any = false;
  deploy: any = false;
  quantity: any = false;
  parentAssetIdFlag: any = false;
  deployCurrentLocation: any = false
  alive: any = true
  warranty: any = false;
  purchase: any = false
  geojsonData: any = {
    "type": "FeatureCollection",
    "features": []
  }
  area: any = []
  multiLatLng: any = false;
  assetStatusList: any = []

  isOriginalCost: any = false;
  isAsset_Category: any = false;
  // isPutToUseDate: any = false;
  isSalvageValue: any = false;
  isAssetLifeNumber: any = false;


  // objectInfoList:any = [];
  parentSelectedList: any = [];
  parentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  jsonString1 = JSON.stringify({
    id: 123,
    asset: 'Epson Multimedia Projector',
    location: 'Karol Bagh'
  });

  branchFilterList: any = []
  locationFilterList: any = []
  departmentFilterList: any = []
  isEditStatus: boolean = false;

  objStatus: any = {
    "userId": 0,
    "issueStatus": "FAULTY",
    "updatedDate": new Date().getTime(),
    "name": "",
    "remarks": ""
  }

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false,
    isVerify: false,
    isApprove: false,
    isIssue: false,
    isAttach: false,
    isRemove: false
  }
  assetRolloutData: any = [];
  userLocations: any = [];

  host: any = ""
  name: any = ""
  groups: any = []
  templates: any = []
  zabbixGroups: any = []
  zabbixTemplates: any = []
  ip: any = ""
  port: any = 0
  snmpCommunity: any = ""
  snmpVersion: any = 0
  snmpContextName: any = ""
  zabbixAvailable: any = "";
  formSubmit: any = false;

  constructor(private ngZone: NgZone, private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    const now = new Date();
    const today = new Date();
    const tomorrow = new Date(today);
    this.isClone = false
    tomorrow.setDate(today.getDate() + 1);
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    console.log("userCred", this.userCred)
    this.actionControls = this.generic_service.checkActionControls(
      window.location.href.split('/').filter(Boolean).pop()?.toLowerCase() || ''
    );

    console.log("actionControls", this.actionControls)

    this.hostGroups()
    this.getTemplates()

    // if(this.userCred.branch ){}


    // Format to YYYY-MM-DD
    this.todayDate = tomorrow.toISOString().split('T')[0];
    const todayYear = today.getFullYear();
    const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
    const todayDay = String(today.getDate()).padStart(2, '0');
    this.currentDate = `${todayYear}-${todayMonth}-${todayDay}`;
    this.cid = Number(sessionStorage.getItem('cid'))
    this.formSubmit = false;


    this.getAllObjectInfo()
    // this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage)
    this.getAllObjectTemplate()
    this.getAllLocation()
    this.getAllBranch()
    this.getAllUomMaster()
    this.getAllGroupList()
    this.getAllTypeList()
    this.getAllObjectCategory()
    this.getAllAssetDepreciationMethod()
    this.getAllDepartment_info()
    this.getAllAssetStatus()
    this.repairInfoForm = this.fb.group({
      description: ['', [Validators.required]],
      repairGivenTo: ['', [Validators.required]],
      repairGivenDate: ['', [Validators.required]],
      repairExpectedEndDate: ['', [Validators.required]],
      userName: ['', [Validators.required]],
      repairCost: ['', [Validators.required]],
      estRepairCost: ['', [Validators.required]],
      phNo: ['', [Validators.required]],
      emailId: ['', [Validators.required]],
      lat: [''],
      lng: ['']
    })



    this.addAsset = this.fb.group({
      description: [''],
      name: [''],
      type: [''],
      group: [''],
      make: [''],
      model: [''],
      originalCost: [''],
      currentCost: [''],
      objectCondition: ['Good'],
      icon: [''],
      givenName: [''],
      serialNumber: [''],
      acquisitionDate: [''],
      salvageValue: [0],
      depreciationMethod: [0],
      assetLifeNumber: [0],
      branch: [''],
      department: [''],
      location: [''],
      lat: [0],
      lng: [0],
      assetMonitoring: [true],
      multiLatLng: [true],
      givenRepair: [true],
      internal: [true],
      routeId: [0],
      assetMonitoringFrequency: [0],
      assetMonitoringTimeSpan: [0],
      asset_Category: ['']
    });

  }

  jsonString: string = "";

  onGivenDateChange(event: any) {
    const value = event.target.value;
    if (value) {
      const parts = value.split('-');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);

      const givenDate = new Date(year, month, day);
      if (!isNaN(givenDate.getTime())) {
        const nextDay = new Date(givenDate);
        nextDay.setDate(givenDate.getDate() + 1);

        const nextYear = nextDay.getFullYear();
        const nextMonth = String(nextDay.getMonth() + 1).padStart(2, '0');
        const nextDate = String(nextDay.getDate()).padStart(2, '0');

        this.minEndDate = `${nextYear}-${nextMonth}-${nextDate}`;
      }
    }
  }

  closeRepair() {
    this.isRepair = false
    this.repairInfoForm.reset()
  }

  closeRepairDone() {
    this.isRepairDone = false
    this.repairInfoForm.reset()
  }


  onItemSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  getMaintenanceType(type: any) {
    for (let list of this.maintenanceType) {
      if (list.value == type) {
        return list.key
      }
    }
    return ""
  }

  openRepair() {
    this.isRepair = !this.isRepair
    if (this.isRepair) {
      setTimeout(() => {
        const element = document.getElementById('repairForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);

    }

  }

  openRepairDone() {
    this.isRepairDone = !this.isRepairDone
  }

  getAllDepartment_info() {
    this.generic_service.getAllDepartment_info().subscribe(
      (res: any) => {
        this.departmentInfoList = res.response

        this.departmentFilterList = (this.departmentInfoList?.filter((department: any) =>
          this.userCred?.department?.includes(department.departmentInfoId)
        )) || [];

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllObjectCategory() {
    this.generic_service.getAllObjectCategory().subscribe(
      (res: any) => {
        this.objectCategoryList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllAssetDepreciationMethod() {
    this.generic_service.getAllAssetDepreciationMethod().subscribe(
      (res: any) => {
        this.assetDepreciationDataList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  editPerformanceMatrixClick() {
    this.performanceMatrixList = []
    this.performanceMatrixList = JSON.parse(JSON.stringify(this.singleObjectInfoData[0].performanceMatrix));
    this.editPerformanceMatrix = !this.editPerformanceMatrix
  }

  editPerformanceMatrixClose() {
    this.editPerformanceMatrix = false
    this.performanceMatrixList = []
  }

  updatePerformanceMatrix() {
    console.log(this.performanceMatrixList)

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "performanceMatrixOfObjectInfo": this.performanceMatrixList,
      "cid": Number(this.cid),
      "objectInfoId": this.objectInfoId
    }

    this.generic_service.updateObjectPerformanceMatrix(body).subscribe(
      (response: any) => {
        this.getObjectInfoById(this.objectInfoId)
        this.editPerformanceMatrix = false
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  onTableDataChange(event: any) {

    console.log(event)
    this.page = event.page;
    this.first = event.first;
    this.tableSize = event.rows;
    console.log(this.page)

    // if(this.searchFilter != ""){
    //   this.getObjectInfoByWildSearchWithPagination(this.page,this.recordsPerPage)
    // }else{
    //   this.getAllObjectInfoWithPagination(this.page,this.recordsPerPage);
    // }

    if (this.searchFilter != "") {
      this.getObjectInfoByWildSearchWithPagination(this.page, this.recordsPerPage)
    } else if (this.selectedFilter != "") {
      this.applyFilter()
    } else {
      this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage)
    }
  }

  getAllObjectTemplate() {
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any) => {
        this.objectTemplateList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  toggleFilter() {
    this.showFilter = !this.showFilter
  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.showFilter = false
    this.formSubmit = false;
    this.searchFilter = ""
    this.resetFilter()
  }

  getObjectTemplateById(objectTemplateId: any) {
    this.generic_service.getObjectTemplateById(objectTemplateId.target.value).subscribe(
      (response: any) => {
        this.singleObjectTemplateData = []

        this.singleObjectTemplateData.push(response.response)
        this.branchCheckBox = response.response.branch || false;
        this.departmentCheckBox = response.response.department || false;
        this.locationCheckBox = response.response.location || false;
        this.makeCheckBox = response.response.make || false;
        this.modelCheckBox = response.response.model || false;
        this.icon = response.response.iconUrl || '';
        this.originalCostCheckBox = response.response.originalCost || false;
        this.currentCostCheckBox = response.response.currentCost || false;
        this.serialNumberCheckBox = response.response.serialNumber || false;
        this.depreciationCheckbox = response.response.depreciationRequired || false;
        this.deploy = response.response.deploy || false;
        this.quantity = response.response.quantity || false;

        this.parentAssetIdFlag = response.response.parentAssetIdFlag || false;
        this.warranty = response.response.warranty || false;
        this.purchase = response.response.purchase || false;
        this.openMapPopup()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  cloneObjectInfoById(objectInfoId: any) {
    this.objectInfoId = objectInfoId
    this.imagesList = []
    this.imagesWithDetails = []
    this.removeLatLng()

    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response: any) => {
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
        this.isRepairGiven = response.response.givenRepair
        this.imagesList = response.response.images || []
        this.imagesWithDetails = response.response.imagesWithDetails || []
        this.getAllMaintenanceScheduleByAssetId(objectInfoId)

        this.singleObjectTemplateData = []


        for (let list of this.objectTemplateList) {
          if (list.name == response.response.name) {
            this.objectTemplateId = list.objectTemplateId
            console.log(list)
            console.log(this.objectTemplateId)
            this.singleObjectTemplateData.push(list)
          }
        }

        this.branchCheckBox = response.response.branchCheckBox || false;
        this.departmentCheckBox = response.response.departmentCheckBox || false;
        this.deployCurrentLocation = response.response.deployCurrentLocation || false;
        this.alive = response.response.alive || false;
        this.locationCheckBox = response.response.locationCheckBox || false;
        this.makeCheckBox = response.response.makeCheckBox || false;
        this.modelCheckBox = response.response.modelCheckBox || false;
        this.icon = response.response.iconUrl || '';
        this.originalCostCheckBox = response.response.originalCostCheckBox || false;
        this.currentCostCheckBox = response.response.currentCostCheckBox || false;
        this.serialNumberCheckBox = response.response.serialNumberCheckBox || false;
        this.depreciationCheckbox = response.response.depreciationCheckbox || false;
        this.deploy = response.response.deploy || false;
        this.objectQty = response.response.objectQty || false;
        this.objectUOM = response.response.objectUOM || false;
        this.quantity = response.response.quantityCheckBox || false;

        this.parentAssetIdFlag = response.response.parentAssetIdFlag || false;
        this.warranty = response.response.warranty || false;
        this.purchase = response.response.purchase || false;
        this.area = response.response?.area
        this.multiLatLng = response.response?.multiLatLng
        if (response.response.lat && response.response.lat != 0 && response.response.lat != null) {
          this.latlng.lat = response.response.lat
          this.latlng.lng = response.response.lng
          this.isLatLng = true
          console.log(this.latlng)

        } else {
          this.latlng.lat = 0
          this.latlng.lng = 0
          this.isLatLng = false
          this.defaultCenter = [17.4051564, 78.4927618];

        }
        this.objectColorCode = response.response.objectColorCode || "";

        this.templateName = response.response.name;
        this.originalCost = response.response.originalCost;
        this.objectCondition = response.response.objectCondition;
        this.assetStatus = response.response.assetStatus || '';
        this.givenName = response.response.givenName;
        this.serialNumber = response.response.serialNumber;
        this.imagesList = response.response.images;
        this.imagesWithDetails = response.response.imagesWithDetails || [];
        this.icon = response.response.icon;
        this.currentCost = response.response.currentCost;
        this.branch = response.response.branch;
        this.department = response.response.department;
        this.make = response.response.make;
        this.model = response.response.model;
        this.location = response.response.location;
        this.assetMonitoring = response.response.assetMonitoring;
        if (response.response.snmpMonitoring) {
          this.ip = response.response.snmpMonitoring.ip || "";
          this.port = response.response.snmpMonitoring.port || 0;
          this.snmpCommunity = response.response.snmpMonitoring.snmpCommunity || "";
          this.snmpVersion = response.response.snmpMonitoring.snmpVersion || 0;
          this.snmpContextName = response.response.snmpMonitoring.snmpContextName || "";
          this.groups = response.response.snmpMonitoring.groups?.[0] || "";
          this.templates = response.response.snmpMonitoring.templates?.[0] || "";
        } else {
          this.ip = "";
          this.port = 0;
          this.snmpCommunity = "";
          this.snmpVersion = 0;
          this.snmpContextName = "";
          this.groups = "";
          this.templates = "";
        }
        this.connectionsList = response.response.connectionDetails || [];
        this.assetHealthList = response.response.assetHealth || [];

        this.performance = response.response.performance || false
        this.timeSpan = response.response.assetPerformance.timeSpan || ""
        this.expectedOutput = response.response.assetPerformance.expectedOutput || ""
        this.uom = response.response.assetPerformance.uom || ""
        if (this.assetHealthList != null && this.assetHealthList.length != 0) {
          this.assetHealth = true
        }

        if (response.response.parentAssetId && response.response.parentAssetId != 0) {
          this.isParentAssetId = true
        } else {
          this.isParentAssetId = false

        }

        this.warranty = response.response.warranty
        this.warrantyInfo = response.response.warrantyInfo

        this.purchase = response.response.purchase
        this.purchaseInfo = response.response.purchaseInfo

        this.parentAssetId = response.response.parentAssetId || 0;


        this.assetMonitoringFrequency = response.response.assetMonitoringFrequency || 0;
        this.assetMonitoringTimeSpan = response.response.assetMonitoringTimeSpan || 0;
        this.nameValue = response.response.nameValue;
        this.performanceMatrix = response.response.performanceMatrix;
        this.acquisitionDate = response.response.acquisitionDate;
        this.salvageValue = response.response.salvageValue;
        this.depreciationMethod = response.response.depreciationMethod;
        this.assetLifeNumber = response.response.assetLifeNumber;
        this.asset_Category = response.response.asset_Category;
        this.tags = []
        if (response.response.tags && response.response.tags != null && response.response.tags != undefined && response.response.tags.length != 0) {
          for (let list of response.response.tags) {
            this.tags.push({
              "tag": list
            })
          }
        }
        this.assetMonitoring = response.response.assetMonitoring;
        this.connectionsList = response.response.connectionDetails || [];
        this.assetHealthList = response.response.assetHealth || [];
        if (this.assetHealthList != null && this.assetHealthList.length != 0) {
          this.assetHealth = true
        }
        this.nameValue = response.response.nameValue;
        this.performanceMatrix = response.response.performanceMatrix;
        this.isClone = true

        // this.openMapPopup()
        this.openMapPopup1()

      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  getObjectInfoById(objectInfoId: any, type?: any) {
    this.isLatLng = false
    this.objectInfoId = objectInfoId
    this.imagesList = []
    this.largeImage = ""
    this.imagesWithDetails = []
    this.parentSelectedList = []
    this.removeLatLng()
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response: any) => {
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
        this.isRepairGiven = response.response.givenRepair
        this.isLock = response.response.lock
        this.imagesList = response.response.images || []
        this.imagesWithDetails = response.response.imagesWithDetails || []
        this.imagesWithDetails = response.response.imagesWithDetails || []
        this.getAllMaintenanceScheduleByAssetId(objectInfoId)
        if (response.response.assetMonitoring) {
          if (response.response.snmpMonitoringId) {
            this.getHostById(response.response.snmpMonitoringId)
          }
        }

        let obj = {
          "Id": response.response.objectInfoId || "",
          "Name": response.response.givenName || "",
          "Condition": response.response.objectCondition || "",
        }
        this.jsonString = JSON.stringify(obj);

        this.singleObjectTemplateData = []


        for (let list of this.objectTemplateList) {
          if (list.name == response.response.name) {
            this.objectTemplateId = list.objectTemplateId
            console.log(list)
            console.log(this.objectTemplateId)
            this.singleObjectTemplateData.push(list)
            console.log(this.singleObjectTemplateData)
          }
        }

        // if(response.response.quantity){

        //   this.generic_service.getAssetRolloutByObjectInfoId(response.response.objectInfoId).subscribe(
        //     (response: any)=>{
        //       this.assetRolloutData = []
        //       this.assetRolloutData = response.response
        //     },
        //     (error: any)=>{
        //       console.log(error)
        //     }
        //   )
        // }
        this.deployCurrentLocation = response.response.deployCurrentLocation || false;
        this.alive = response.response.alive || false;
        this.branchCheckBox = response.response.branchCheckBox || false;
        this.departmentCheckBox = response.response.departmentCheckBox || false;
        this.locationCheckBox = response.response.locationCheckBox || false;
        this.makeCheckBox = response.response.makeCheckBox || false;
        this.modelCheckBox = response.response.modelCheckBox || false;
        this.originalCostCheckBox = response.response.originalCostCheckBox || false;
        this.currentCostCheckBox = response.response.currentCostCheckBox || false;
        this.serialNumberCheckBox = response.response.serialNumberCheckBox || false;
        this.depreciationCheckbox = response.response.depreciationCheckbox || false;
        this.deploy = response.response.deploy || false;
        this.quantity = response.response.quantityCheckBox || false;
        this.warranty = response.response.warranty || false;
        this.purchase = response.response.purchase || false;
        this.area = response.response?.area
        this.multiLatLng = response.response?.multiLatLng
        if (response.response.lat && response.response.lat != 0 && response.response.lat != null) {
          this.latlng.lat = response.response.lat
          this.latlng.lng = response.response.lng
          this.isLatLng = true
          console.log(this.latlng)

        } else {
          this.latlng.lat = 0
          this.latlng.lng = 0
          this.isLatLng = false
          this.defaultCenter = [17.4051564, 78.4927618];

        }
        this.objectColorCode = response.response.objectColorCode || "";

        this.templateName = response.response.name;
        this.originalCost = response.response.originalCost;
        this.objectCondition = response.response.objectCondition;
        this.assetStatus = response.response.assetStatus;
        this.givenName = response.response.givenName;
        this.serialNumber = response.response.serialNumber;
        this.imagesList = response.response.images;
        this.icon = response.response.icon || "";
        this.currentCost = response.response.currentCost;
        this.branch = response.response.branch;
        this.department = response.response.department;
        this.make = response.response.make;
        this.model = response.response.model;
        this.location = '';
        this.objectQty = response.response.objectQty
        this.availableQty = response.response.availableQty

        if (response.response.givenRepair) {
          if (response.response.repairInfos) {
            for (let list of response.response.repairInfos) {
              if (!list.repairDone) {
                this.repairInfoForm.patchValue({
                  userName: list.userName,
                  repairGivenTo: list.repairGivenTo,
                  repairGivenDate: list.repairGivenDate,
                  repairExpectedEndDate: list.repairExpectedEndDate,
                  repairCost: list.repairCost,
                  estRepairCost: list.estRepairCost,
                  phNo: list.phNo,
                  emailId: list.emailId,
                  description: list.description,
                })
              }
            }
          }

        }

        //     this.repairInfoForm.patchValue({
        //       userName: list.userName,
        //     })

        const locationFromResponse = response?.response?.location;

        if (locationFromResponse) {
          const found = this.locationList.some((list: any) => list.zone === locationFromResponse);
          if (found) {
            this.location = locationFromResponse;
          }
        }

        this.assetMonitoring = response.response.assetMonitoring;
        this.isNmsAdded = !!response.response.snmpMonitoringId;
        if (response.response.snmpMonitoring) {
          this.ip = response.response.snmpMonitoring.ip || "";
          this.port = response.response.snmpMonitoring.port || 0;
          this.snmpCommunity = response.response.snmpMonitoring.snmpCommunity || "";
          this.snmpVersion = response.response.snmpMonitoring.snmpVersion || 0;
          this.snmpContextName = response.response.snmpMonitoring.snmpContextName || "";
          this.groups = response.response.snmpMonitoring.groups?.[0] || "";
          this.templates = response.response.snmpMonitoring.templates?.[0] || "";
        } else {
          this.ip = "";
          this.port = 0;
          this.snmpCommunity = "";
          this.snmpVersion = 0;
          this.snmpContextName = "";
          this.groups = "";
          this.templates = "";
        }
        this.connectionsList = response.response.connectionDetails || [];
        this.assetHealthList = response.response.assetHealth || [];

        this.performance = response.response.performance || false
        this.timeSpan = response.response?.assetPerformance?.timeSpan || ""
        this.expectedOutput = response.response?.assetPerformance?.expectedOutput || ""
        this.uom = response.response.assetPerformance?.uom || ""
        if (this.assetHealthList != null && this.assetHealthList.length != 0) {
          this.assetHealth = true
        }

        if (response.response.parentAssetId && response.response.parentAssetId != 0) {
          this.isParentAssetId = true
        } else {
          this.isParentAssetId = false

        }

        this.warranty = response.response.warranty
        this.warrantyInfo = response.response.warrantyInfo

        this.purchase = response.response.purchase
        this.purchaseInfo = response.response.purchaseInfo

        this.parentAssetId = response.response.parentAssetId || 0;


        this.assetMonitoringFrequency = response.response.assetMonitoringFrequency || 0;
        this.assetMonitoringTimeSpan = response.response.assetMonitoringTimeSpan || 0;
        this.nameValue = response.response.nameValue;
        this.performanceMatrix = response.response.performanceMatrix;
        this.acquisitionDate = response.response.acquisitionDate;
        this.salvageValue = response.response.salvageValue;
        this.depreciationMethod = response.response.depreciationMethod;

        if (this.depreciationMethod && this.depreciationMethod != "" && this.depreciationMethod != null) {
          this.depreciationMethodChange(this.depreciationMethod)
        }

        this.assetLifeNumber = response.response.assetLifeNumber;
        this.asset_Category = response.response.asset_Category;
        this.tags = []
        if (response.response.tags && response.response.tags != null && response.response.tags != undefined && response.response.tags.length != 0) {
          for (let list of response.response.tags) {
            this.tags.push({
              "tag": list
            })
          }
        }

        this.parentAssetIdFlag = response.response.parentAssetIdFlag || false;
        this.parentSelectedList = []
        if (response.response.parentAssetId && response.response.parentAssetId != null && response.response.parentAssetId != undefined && response.response.parentAssetId.length != 0) {
          for (let list of response.response.parentAssetId) {
            for (let object of this.objectInfoList) {
              if (list == object.objectInfoId) {
                this.parentSelectedList.push(
                  {
                    objectInfoId: object.objectInfoId,
                    givenName: object.givenName
                  }
                )
              }
            }
          }
        }

        this.assetMonitoring = response.response.assetMonitoring;
        this.connectionsList = response.response.connectionDetails || [];
        this.assetHealthList = response.response.assetHealth || [];
        if (this.assetHealthList != null && this.assetHealthList.length != 0) {
          this.assetHealth = true
        }
        this.nameValue = response.response.nameValue;
        this.performanceMatrix = response.response.performanceMatrix;



        if (type == 'view') {
          if (response.response.quantityCheckBox) {

            this.generic_service.getAssetRolloutByObjectInfoId(response.response.objectInfoId).subscribe(
              (response: any) => {

                this.assetRolloutData = []
                this.assetRolloutData = response.response
                this.openMapPopup3()

              },
              (error: any) => {
                console.log(error)
              }
            )
          } else {
            this.openMapPopup3()
          }
        }

        if (type == 'edit') {
          this.openMapPopup2()
        }

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllMaintenanceScheduleByAssetId(objectInfoId: any) {
    this.generic_service.getAllMaintenanceScheduleByAssetId(objectInfoId).subscribe(
      (response: any) => {
        this.maintenanceScheduleList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  // getAllObjectInfoWithPagination(pageNumber: any, recordsPerPage: any) {
  //   this.isLoading = true
  //   this.generic_service.getAllObjectInfoWithPagination(pageNumber, recordsPerPage).subscribe(
  //     (response: any) => {
  //       console.log(response)
  //       this.objectInfoListWithPagination = response.response.objectInfoList
  //       this.count = response.response.totalRecords
  //       this.isLoading = false
  //     },
  //     (error: any) => {
  //       this.isLoading = false
  //       console.log(error)
  //     }
  //   )
  // }

  getAllObjectInfoWithPaginationAndLocation(pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "location": this.userLocations || [],
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage,

    }
    console.log(body)

    this.isLoading = true
    this.generic_service.getAllObjectInfoWithPaginationAndLocation(body).subscribe(
      (response: any) => {
        this.objectInfoListWithPagination = response.response.objectInfoList
        this.count = response.response.totalRecords
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }

  getAllObjectInfo() {
    this.isLoading = true
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        this.objectInfoList = response.response
        this.objectInfoListFilter = response.response
        // this.count = response.response.length
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }

  remove() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeHoldingModalButton")?.click()
    this.formSubmit = false;

    this.singleObjectTemplateData = []
    this.largeImage = ""
    this.objectTemplateId = ""
    this.originalCost = ""
    this.currentCost = ""
    this.branch = ""
    this.department = ""
    this.objectCondition = ""
    this.assetStatus = ""
    this.givenName = ""
    this.location = ""
    this.serialNumber = ""
    this.maintenanceList = []
    this.imagesList = []
    this.imagesWithDetails = []
    this.assetHealth = false
    this.assetMonitoring = false
    this.connectionsList = []
    this.assetHealthList = []
    this.isClone = false
    this.objectInfoId = ""
    this.repairInfoForm.reset()

    this.singleObjectInfoData = []
    this.isRepairGiven = false
    this.imagesList = []
    this.imagesWithDetails = []
    this.singleObjectTemplateData = []
    this.parentSelectedList = []

    this.isLock = false
    this.isNmsAdded = false

    this.templateName = "";
    this.originalCost = null;
    this.objectCondition = "";
    this.assetStatus = ""
    this.givenName = "";
    this.serialNumber = "";
    this.imagesList = [];
    this.imagesWithDetails = []
    this.icon = "";
    this.currentCost = null;
    this.branch = "";
    this.branchId = ""
    this.department = "";
    this.make = "";
    this.model = "";
    this.location = "";
    this.assetMonitoring = false;
    this.connectionsList = [];
    this.assetHealthList = [];
    this.assetHealth = false
    this.assetMonitoringFrequency = null;
    this.assetMonitoringTimeSpan = null;
    this.nameValue = [];
    this.performanceMatrix = [];
    this.acquisitionDate = "";
    this.salvageValue = null;
    this.depreciationMethod = null;
    this.assetLifeNumber = null;
    this.asset_Category = "";
    this.tags = []
    this.parentSelectedList = []

    this.timeSpan = ""
    this.expectedOutput = ""
    this.uom = ""
    this.parentAssetId = 0

    this.isOriginalCost = false;
    this.isAsset_Category = false;
    // this.isPutToUseDate = false;
    this.isSalvageValue = false;
    this.isAssetLifeNumber = false;
    this.proofFile = ""
    this.proofFileType = ""
    this.proofFilePath = ""




    this.currentCost = ""
    this.branch = ""
    this.department = ""
    this.make = ""
    this.model = ""
    this.objectQty = 0
    this.objectUOM = ""
    this.objectQty = 0

    this.branchCheckBox = false
    this.departmentCheckBox = false
    this.locationCheckBox = false
    this.makeCheckBox = false
    this.modelCheckBox = false
    this.originalCostCheckBox = false
    this.currentCostCheckBox = false
    this.serialNumberCheckBox = false
    this.depreciationCheckbox = false
    this.deploy = false
    this.quantity = false
    this.warranty = false
    this.purchase = false
    this.deployCurrentLocation = false
    this.alive = true;
    this.isRepair = false
  }


  addRepairInfos(isRepair: any) {

    // for(let list of this.usersList){
    //   if(list.userId == Number(this.repairInfoForm.get('repairGivenTo').value)){
    //     this.repairInfoForm.patchValue({
    //       userName: list.userName,
    //     })
    //   }
    // }


    if (this.repairFormSubmit) {
      return
    }
    console.log(this.repairInfoForm.value)

    this.repairFormSubmit = true;

    if (isRepair) {
      const requiredFields = [
        'repairGivenTo',
        'repairGivenDate',
        'repairExpectedEndDate',
        'userName',
        'phNo',
        'emailId',
        'estRepairCost',
        'description'
      ];
      for (const field of requiredFields) {
        if (!this.repairInfoForm.get(field)?.value) {
          this.toastr.error("please fill all required fields");
          this.repairFormSubmit = false;
          return;
        }
      }

      const givenDateVal = this.repairInfoForm.get('repairGivenDate')?.value;
      const expectedEndDateVal = this.repairInfoForm.get('repairExpectedEndDate')?.value;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const givenParts = givenDateVal.split('-');
      const givenDate = new Date(parseInt(givenParts[0], 10), parseInt(givenParts[1], 10) - 1, parseInt(givenParts[2], 10));
      givenDate.setHours(0, 0, 0, 0);

      if (givenDate > today) {
        this.toastr.error("Repair given date must not be later than the current date");
        this.repairFormSubmit = false;
        return;
      }

      const expectedParts = expectedEndDateVal.split('-');
      const expectedEndDate = new Date(parseInt(expectedParts[0], 10), parseInt(expectedParts[1], 10) - 1, parseInt(expectedParts[2], 10));
      expectedEndDate.setHours(0, 0, 0, 0);

      if (expectedEndDate <= givenDate) {
        this.toastr.error("Repair expected end date must be later than repair given date");
        this.repairFormSubmit = false;
        return;
      }
    } else {
      const requiredFields = ['description', 'repairCost'];
      for (const field of requiredFields) {
        if (!this.repairInfoForm.get(field)?.value) {
          this.toastr.error("please fill all required fields");
          this.repairFormSubmit = false;
          return;
        }
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.repairInfoForm.get('description').value,
      "to": "Good",
      "cid": Number(this.cid),
      "objectInfoId": this.objectInfoId,
      "repairInfo": {
        "repairGivenTo": this.repairInfoForm.get('repairGivenTo').value,
        "repairGivenDate": this.repairInfoForm.get('repairGivenDate').value,
        "repairExpectedEndDate": this.repairInfoForm.get('repairExpectedEndDate').value,
        "description": this.repairInfoForm.get('description').value,
        "userName": this.repairInfoForm.get('userName').value,
        "phNo": this.repairInfoForm.get('phNo').value,
        "emailId": this.repairInfoForm.get('emailId').value,
        "repairCost": this.repairInfoForm.get('repairCost').value,
        "estRepairCost": this.repairInfoForm.get('estRepairCost').value,
        "repairDone": !isRepair,
        "lat": "",
        "lng": "",
      },
      "givenRepair": isRepair
    }

    console.log(body)
    this.generic_service.updateObjectInfoByRepairInfo(body).subscribe(
      (response: any) => {
        this.closeRepair()
        this.closeRepairDone()
        this.getObjectInfoById(this.objectInfoId)
        this.toastr.success(response.message);
        this.repairFormSubmit = false;

      },
      (error: any) => {
        console.log(error)
        this.repairFormSubmit = false;
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  getTemplates() {
    this.generic_service.getTemplates().subscribe(
      (response: any) => {
        console.log(response)
        this.zabbixTemplates = response.result
      }
    )
  }

  getHostById(hostId: any) {
    this.generic_service.getHostById(hostId).subscribe(
      (response: any) => {
        console.log(response);
        console.log(response.result[0].interfaces[0].available);

        const status = response.result[0].interfaces[0].available;

        switch (status) {
          case "0":
            this.zabbixAvailable = 'Unknown';
            break;
          case "1":
            this.zabbixAvailable = 'Available';
            break;
          case "2":
            this.zabbixAvailable = 'Unavailable';
            break;
          default:
            this.zabbixAvailable = '--';
        }
      }
    );
  }

  hostGroups() {
    this.generic_service.hostGroups().subscribe(
      (response: any) => {
        console.log(response)
        this.zabbixGroups = response.result
      }
    )
  }


  addHost() {
    const body: any = {
      "host": this.cid + "_" + this.host,
      "name": this.name,
      "groups": [this.groups],
      "templates": [this.templates],
      "ip": this.ip,
      "port": this.port,
      "snmpCommunity": this.snmpCommunity,
      "snmpVersion": this.snmpVersion,
      "snmpContextName": this.snmpContextName
    }
    console.log(body)

    this.generic_service.addHost(body).subscribe(
      (response: any) => {
        console.log(response)
        // this.toastr.success(response.message);
        this.host = ""
        this.name = ""
        this.groups = []
        this.templates = []
        this.ip = ""
        this.port = 0
        this.snmpCommunity = ""
        this.snmpVersion = 0
        this.snmpContextName = ""
      },
      (error: any) => {
        console.log(error)
        // this.toastr.error(error.error.errors[0].description);
      }
    )


  }

  addObjectInfo() {
    console.log(this.isLatLng)

    if (this.formSubmit) {
      return
    }


    if (
      this.givenName == "" ||
      this.objectCondition == "" ||
      this.objectTemplateId == "" ||
      this.location == ""
      // this.acquisitionDate == "" ||
      // this.salvageValue == "" ||
      // this.depreciationMethod == "" ||
      // this.assetLifeNumber == ""

    ) {
      this.toastr.error("Please fill in all required fields");
      this.formSubmit = false;

      return
    }

    let method: any = ""
    for (let list of this.assetDepreciationDataList) {
      if (list.assetDepreciationMethodId == this.depreciationMethod) {
        method = list.methodName
      }
    }

    if (this.singleObjectTemplateData[0]?.depreciationRequired) {
      if (method == "Written Down Value (WDV)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          this.formSubmit = false;

          return
        }
      }

      if (method == "Straight Line Method (SLM)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          this.formSubmit = false;

          return
        }
      }
    }

    if (this.assetMonitoring) {
      if (
        this.ip == "" ||
        this.port == 0 ||
        this.snmpCommunity == "" ||
        this.snmpVersion == 0 ||
        this.groups.length == 0 ||
        this.templates.length == 0

      ) {
        this.toastr.error("Please fill in all required fields in NMS.");
        this.formSubmit = false;

        return
      }
    }

    if (!this.assetMonitoring) {
      this.connectionsList = []
    }

    if (!this.assetHealth) {
      this.assetHealthList = []
    }

    let tags: any = []
    for (let list of this.tags) {
      if (list.tag != "") {
        tags.push(list.tag)
      }
    }

    let lat: any = 0
    let lng: any = 0

    if (this.isLatLng) {
      lat = this.latlng.lat
      lng = this.latlng.lng
    }


    for (let list of this.branchList) {
      if (list.name == this.branch) {
        this.branchId = list.branchMasterId
      }
    }

    let loc: any
    for (let list of this.locationList) {
      if (list.zone == this.location) {
        loc = list
      }
    }

    let parentAssetId: any = []

    for (let list of this.parentSelectedList) {
      parentAssetId.push(list.objectInfoId)
    }

    let currentWarrantyInfo = this.isClone ? this.warrantyInfo : this.singleObjectTemplateData[0]?.warrantyInfo;
    if (currentWarrantyInfo) {
      for (let list of currentWarrantyInfo) {
        if (list.key == "Coverage Start Date" || list.key == "Coverage End Date") {
          if (list.value) {
            list.value = new Date(list.value).getTime();
          }
        }
      }
    }

    this.formSubmit = true;

    console.log(currentWarrantyInfo)

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.isClone ? "cloned" : '',
      "layerInfoId": 0,
      "name": this.singleObjectTemplateData[0]?.name,
      "type": this.singleObjectTemplateData[0]?.type,
      "group": this.singleObjectTemplateData[0]?.group,
      "originalCost": this.originalCost,
      "objectCondition": this.objectCondition,
      "assetStatus": this.assetStatus,
      "givenName": this.givenName,
      "serialNumber": this.serialNumber,
      "conditionModifiedBy": [],
      "images": this.imagesList,
      "imagesWithDetails": this.imagesWithDetails,
      "icon": this.icon,
      "holding": [
        {
          "allocationRegisterId": 0,
          "userId": 0,
          "name": "COMPANY",
          "date": new Date().getTime()
        }
      ],
      "latestHolding": {
        "allocationRegisterId": 0,
        "userId": 0,
        "name": "COMPANY",
        "date": new Date().getTime()
      },
      "currentCost": this.currentCost,
      "branch": this.branch,
      "department": this.department,
      "make": this.make,
      "model": this.model,
      "objectQty": this.objectQty || 0,
      "objectUOM": this.objectUOM || "",
      "availableQty": this.objectQty || 0,
      "branchId": this.branchId,
      "country": loc.country,
      "provinceOrState": loc.provinceOrState,
      "district": loc.district,
      "zone": loc.zone,
      "postalCode": loc.postalCode,
      "city": loc.city,
      "location": this.location,
      "assetMonitoring": this.assetMonitoring,
      "connectionDetails": this.connectionsList,
      "assetMonitoringFrequency": this.assetMonitoringFrequency,
      "assetMonitoringTimeSpan": this.assetMonitoringTimeSpan,
      "assetHealth": this.assetHealthList,
      "routeId": this.singleObjectTemplateData[0]?.routeId,
      "subGroups": this.singleObjectTemplateData[0]?.subGroups,
      "nameValue": this.isClone ? this.nameValue : this.singleObjectTemplateData[0]?.nameValue,
      "performanceMatrix": this.isClone ? this.performanceMatrix : this.singleObjectTemplateData[0]?.performanceMatrix,
      "cid": this.singleObjectTemplateData[0]?.cid,
      "repairInfos": [],
      "multiLatLng": false,
      "acquisitionDate": this.acquisitionDate,
      "salvageValue": this.salvageValue,
      "depreciationMethod": this.depreciationMethod,
      "assetLifeNumber": this.assetLifeNumber,
      "asset_Category": this.asset_Category,
      "tags": tags,
      "lat": lat,
      "lng": lng,
      // "parentAssetId": this.parentAssetId,
      "addDeleteIdsObjectInfo": {
        "assetIds": parentAssetId,
        "add": true,
        "parentIds": true
      },
      "parentAssetId": parentAssetId,
      "childAssetId": [],
      "performance": this.performance,
      "assetPerformance": {
        "timeSpan": this.timeSpan,
        "expectedOutput": this.expectedOutput,
        "uom": this.uom
      },
      "warrantyInfo": this.isClone ? this.warrantyInfo : this.singleObjectTemplateData[0]?.warrantyInfo,
      "purchaseInfo": this.isClone ? this.purchaseInfo : this.singleObjectTemplateData[0]?.purchaseInfo,
      "branchCheckBox": this.branchCheckBox,
      "departmentCheckBox": this.departmentCheckBox,
      "locationCheckBox": this.locationCheckBox,
      "makeCheckBox": this.makeCheckBox,
      "modelCheckBox": this.modelCheckBox,
      "originalCostCheckBox": this.originalCostCheckBox,
      "currentCostCheckBox": this.currentCostCheckBox,
      "serialNumberCheckBox": this.serialNumberCheckBox,
      "depreciationCheckbox": this.depreciationCheckbox,
      "deploy": this.deploy,
      "parentAssetIdFlag": this.parentAssetIdFlag,
      "quantityCheckBox": this.quantity,
      "warranty": this.warranty,
      "purchase": this.purchase,
      "alive": false,
      "deployCurrentLocation": this.deployCurrentLocation,
      "available": true,
      "snmpMonitoring": this.assetMonitoring ? {
        "host": "",
        "name": this.givenName,
        "groups": [this.groups],
        "templates": [this.templates],
        "ip": this.ip,
        "port": this.port,
        "snmpCommunity": this.snmpCommunity,
        "snmpVersion": this.snmpVersion,
        "snmpContextName": this.snmpContextName
      } : null,
      "snmpMonitoringId": "",
      "stockPointStatus": loc.stockPoint || false,
      "stockPointId": loc.locationId || 0,
      "stockPointName": loc.zone || ""

    }

    console.log(body)
    this.generic_service.addObjectInfo(body).subscribe(
      (response: any) => {

        // if (this.assetMonitoring) {
        //   this.host = response.response.objectInfoId
        //   this.name = response.response.givenName

        //   this.addHost()

        // }
        this.formSubmit = false;


        for (let list of this.maintenanceList) {
          let body = {
            "version": 0,
            "isActive": true,
            "description": list.description,
            "assetId": response.response.objectInfoId,
            "assetName": response.response.givenName,
            "maintenanceType": list.maintenanceType,
            "frequency": list.frequency,
            "nextDueDate": list.nextDueDate,
            "lastPerformed": "",
            "cid": Number(this.cid),
            "images": []
          }
          console.log(body)

          this.addMaintenanceSchedule(body)
        }

        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()
        document.getElementById("closeModalButtonClone")?.click()


        this.toastr.success(response.message);
        this.singleObjectTemplateData = []
        this.originalCost = ""
        this.currentCost = ""
        this.branch = ""
        this.department = ""
        this.objectCondition = ""
        this.deployCurrentLocation = false
        this.alive = true;
        this.givenName = ""
        this.location = ""
        this.serialNumber = ""
        this.getAllObjectInfo()
        this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);
        this.maintenanceList = []
        this.imagesList = []
        this.imagesWithDetails = []
        this.assetHealth = false
        this.assetMonitoring = false
        this.connectionsList = []
        this.assetHealthList = []
        this.asset_Category = ""
        this.acquisitionDate = ""
        this.salvageValue = 0
        this.depreciationMethod = 0
        this.assetLifeNumber = 0
        this.tags = []
        this.objectQty = ""
        this.isClone = false
        this.remove()
        this.latlng = {}
        this.isLatLng = false
        this.isClone = false
        this.formSubmit = false;

      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        this.formSubmit = false;

        console.log(error)
      }
    )
  }

  updateObjectInfo() {


    if (
      this.givenName == "" ||
      this.objectCondition == "" ||
      this.objectTemplateId == "" ||
      this.location == ""

    ) {
      this.toastr.error("Please fill in all required fields");

      return
    }


    let method: any = ""
    for (let list of this.assetDepreciationDataList) {
      if (list.assetDepreciationMethodId == this.depreciationMethod) {
        method = list.methodName
      }
    }

    if (this.singleObjectTemplateData[0]?.depreciationRequired) {
      if (method == "Written Down Value (WDV)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          return
        }
      }

      if (method == "Straight Line Method (SLM)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          return
        }
      }
    }


    if (this.assetMonitoring && !this.isNmsAdded) {
      if (
        this.ip == "" ||
        this.port == 0 ||
        this.snmpCommunity == "" ||
        this.snmpVersion == 0 ||
        this.groups.length == 0 ||
        this.templates.length == 0
      ) {
        this.toastr.error("Please fill in all required fields in NMS.");
        return
      }
    }

    if (!this.assetMonitoring) {
      this.connectionsList = []
    }

    if (!this.assetHealth) {
      this.assetHealthList = []
    }

    let tags: any = []
    for (let list of this.tags) {
      if (list.tag != "") {
        tags.push(list.tag)
      }
    }

    let lat: any = 0
    let lng: any = 0

    if (this.isLatLng) {
      lat = this.latlng.lat
      lng = this.latlng.lng
    }


    for (let list of this.branchList) {
      if (list.name == this.branch) {
        this.branchId = list.branchMasterId
      }
    }

    let loc: any
    for (let list of this.locationList) {
      if (list.zone == this.location) {
        loc = list
      }
    }

    let parentAssetId: any = []

    for (let list of this.parentSelectedList) {
      parentAssetId.push(list.objectInfoId)
    }

    if (this.warrantyInfo) {
      for (let list of this.warrantyInfo) {
        if (list.key == "Coverage Start Date" || list.key == "Coverage End Date") {
          if (list.value) {
            list.value = new Date(list.value).getTime();
          }
        }
      }
    }


    let body = {
      "version": 0,
      "isActive": true,
      "description": this.singleObjectInfoData[0].description,
      "layerInfoId": this.singleObjectInfoData[0].layerInfoId,
      "name": this.singleObjectTemplateData[0]?.name,
      "type": this.singleObjectTemplateData[0]?.type,
      "group": this.singleObjectTemplateData[0]?.group,
      "originalCost": this.originalCost,
      "objectInfoId": this.singleObjectInfoData[0].objectInfoId,
      "objectCondition": this.objectCondition,
      "assetStatus": this.assetStatus,
      "givenName": this.givenName,
      "serialNumber": this.serialNumber,
      "conditionModifiedBy": this.singleObjectTemplateData[0]?.conditionModifiedBy,
      "images": this.imagesList,
      "imagesWithDetails": this.imagesWithDetails,
      "icon": this.icon,
      "currentCost": this.currentCost,
      "branch": this.branch,
      "department": this.department,
      "make": this.make,
      "model": this.model,
      "country": loc.country,
      "provinceOrState": loc.provinceOrState,
      "district": loc.district,
      "zone": loc.zone,
      "postalCode": loc.postalCode,
      "city": loc.city,
      "location": this.location,
      "assetMonitoring": this.assetMonitoring,
      "connectionDetails": this.connectionsList,
      "assetHealth": this.assetHealthList,
      "routeId": this.singleObjectTemplateData[0]?.routeId,
      "subGroups": this.singleObjectTemplateData[0]?.subGroups,
      "nameValue": this.nameValue,
      "objectColorCode": this.objectColorCode,
      "performanceMatrix": this.singleObjectTemplateData[0]?.performanceMatrix,
      "cid": this.singleObjectTemplateData[0]?.cid,
      "repairInfos": this.singleObjectInfoData[0].repairInfos,
      "multiLatLng": this.singleObjectInfoData[0].multiLatLng,
      "available": this.singleObjectInfoData[0].available,
      "snmpMonitoring": this.assetMonitoring ? {
        "host": "",
        "name": this.givenName,
        "groups": [this.groups],
        "templates": [this.templates],
        "ip": this.ip,
        "port": this.port,
        "snmpCommunity": this.snmpCommunity,
        "snmpVersion": this.snmpVersion,
        "snmpContextName": this.snmpContextName
      } : null,
      "snmpMonitoringId": this.singleObjectInfoData[0].snmpMonitoringId,
      "area": this.area,
      "lat": lat,
      "lng": lng,
      "parentAssetId": parentAssetId,
      "addDeleteIdsObjectInfo": {
        "assetIds": parentAssetId,
        "add": true,
        "parentIds": true
      },
      "holding": this.singleObjectInfoData[0].holding || [],
      "latestHolding": this.singleObjectInfoData[0].latestHolding || {},
      "givenRepair": this.singleObjectInfoData[0].givenRepair,
      "internal": this.singleObjectInfoData[0].internal,

      "acquisitionDate": this.acquisitionDate,
      "salvageValue": this.salvageValue,
      "depreciationMethod": this.depreciationMethod,
      "assetLifeNumber": this.assetLifeNumber,
      "asset_Category": this.asset_Category,
      "branchId": this.branchId,
      "assetMonitoringFrequency": this.assetMonitoringFrequency,
      "assetMonitoringTimeSpan": this.assetMonitoringTimeSpan,

      "branchCheckBox": this.branchCheckBox,
      "departmentCheckBox": this.departmentCheckBox,
      "locationCheckBox": this.locationCheckBox,
      "makeCheckBox": this.makeCheckBox,
      "modelCheckBox": this.modelCheckBox,
      "originalCostCheckBox": this.originalCostCheckBox,
      "currentCostCheckBox": this.currentCostCheckBox,
      "serialNumberCheckBox": this.serialNumberCheckBox,
      "depreciationCheckbox": this.depreciationCheckbox,
      "deploy": this.deploy,
      "quantity": this.quantity,
      "quantityCheckBox": this.quantity,
      "parentAssetIdFlag": this.parentAssetIdFlag,
      "warranty": this.warranty,
      "purchase": this.purchase,
      "objectQty": this.objectQty,
      "availableQty": this.availableQty,
      "performance": this.performance,
      "assetPerformance": {
        "timeSpan": this.timeSpan,
        "expectedOutput": this.expectedOutput,
        "uom": this.uom
      },
      "warrantyInfo": this.warrantyInfo,
      "purchaseInfo": this.purchaseInfo,
      "deployCurrentLocation": this.deployCurrentLocation,
      "alive": this.alive,
      "stockPointStatus": loc.stockPoint || false,
      "stockPointId": loc.locationId || 0,
      "stockPointName": loc.zone || ""
    }

    console.log(body)
    this.generic_service.updateObjectInfo(body).subscribe(
      (response: any) => {
        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()
        document.getElementById("closeModalEdit")?.click()

        for (let list of this.maintenanceList) {
          let body = {
            "version": 0,
            "isActive": true,
            "description": list.description,
            "assetId": response.response.objectInfoId,
            "assetName": response.response.givenName,
            "maintenanceType": list.maintenanceType,
            "frequency": list.frequency,
            "nextDueDate": list.nextDueDate,
            "lastPerformed": "",
            "cid": Number(this.cid),
            "images": []
          }

          this.addMaintenanceSchedule(body)
        }



        this.toastr.success(response.message);
        this.singleObjectTemplateData = []
        this.originalCost = ""
        this.currentCost = ""
        this.branch = ""
        this.department = ""
        this.objectCondition = ""
        this.givenName = ""
        this.location = ""
        this.objectQty = ""
        this.serialNumber = ""
        this.getAllObjectInfo()
        this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);
        this.maintenanceList = []
        this.imagesList = []
        this.remove()
        this.imagesWithDetails = []
        this.assetHealth = false
        this.assetMonitoring = false
        this.connectionsList = []
        this.assetHealthList = []
        this.assetMonitoringFrequency = 0
        this.assetMonitoringTimeSpan = 0
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  addTag() {
    this.tags.push(
      {
        tag: "",
      }
    )
  }

  removeTag(index: any) {
    this.tags.splice(index, 1)
  }


  addMaintenance() {
    this.maintenanceList.push(
      {
        "description": "",
        "maintenanceType": "",
        "frequency": "",
        "nextDueDate": "",
        "lastPerformed": "",
      }
    )
  }

  removeMaintenance(index: any) {
    this.maintenanceList.splice(index, 1)
  }

  addMaintenanceSchedule(body: any) {
    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any) => {
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  depreciationMethodChange(depreciationMethod: any) {

    let method: any = ""
    for (let list of this.assetDepreciationDataList) {
      if (list.assetDepreciationMethodId == Number(depreciationMethod)) {
        method = list.methodName
      }
    }

    console.log(method)
    this.isOriginalCost = false;
    this.isAsset_Category = false;
    // this.isPutToUseDate = false;
    this.isSalvageValue = false;
    this.isAssetLifeNumber = false;

    if (method == "Written Down Value (WDV)") {
      this.isOriginalCost = true;
      this.isAsset_Category = true;
      // this.isPutToUseDate = true;
    }

    if (method == "Straight Line Method (SLM)") {
      this.isOriginalCost = true;
      // this.isPutToUseDate = true;
      this.isSalvageValue = true;
      this.isAssetLifeNumber = true;
    }
  }

  locationChange(loc: any, isInit: boolean = false) {
    console.log(loc)
    if (!isInit) {
      this.removeLatLng();
    }
    for (let list of this.locationList) {
      if (list.zone == loc) {
        console.log(list)

        if (this.map) {
          if (this.drawnItems) {
            this.drawnItems.clearLayers();
          }
          if ((this as any).locationPolygon) {
            this.map.removeLayer((this as any).locationPolygon);
            (this as any).locationPolygon = null;
          }

          if (list.lngLat && list.lngLat.length > 0) {
            const latLngs = list.lngLat
              .filter((item: { x: any; y: any }) => item.x && item.y)
              .map((item: { x: any; y: any }) => [item.y, item.x]);

            if (latLngs.length > 0) {
              if (this.drawnItems) {
                L.polygon(latLngs, { color: 'blue' }).addTo(this.drawnItems);
              } else {
                (this as any).locationPolygon = L.polygon(latLngs, { color: 'blue' }).addTo(this.map);
              }
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, { padding: [20, 20] });
              this.map.invalidateSize();
            }
            console.log(latLngs)
          }
        }

      }
    }
  }


  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
        this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => {
        this.branchList = response.response;
        this.branchFilterList = this.branchList.filter((branch: any) =>
          this.userCred.branch?.includes(branch.branchMasterId)
        ) || [];
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.objectInfoId = id;
    this.recordId = record.objectInfoId;
    this.recordName = record.givenName;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

  loadData() {
    if (this.searchFilter != "") {
      this.getObjectInfoByWildSearchWithPagination(this.page, this.recordsPerPage)
    } else if (this.selectedFilter != "") {
      this.applyFilter()
    } else {
      this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);
    }
  }

  deleteAsset() {
    this.generic_service.deleteObjectInfo(this.objectInfoId).subscribe(
      (response: any) => {
        document.getElementById("deleteModalButton1")?.click()
        this.loadData()
        this.toastr.success(response.message)
        this.recordName = ""
        this.recordId = ""
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


  getObjectInfoByParentAssetIdWithPagination(parentAssetId: any, pageNumber: any, recordsPerPage: any) {
    this.generic_service.getObjectInfoByParentAssetIdWithPagination(parentAssetId, pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllModelByAndCidWIthPagination(model: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "model": model,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllModelByAndCidWIthPagination(body).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllModelByAndCid(model: any) {
    this.generic_service.getAllModelByAndCid(model).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return
        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }


  getAllMakeByAndCidWIthPagination(make: any, pageNumber: any, recordsPerPage: any) {
    const body: any = {
      "make": make,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllMakeByAndCidWIthPagination(body).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllMakeByAndCid(make: any) {
    this.generic_service.getAllMakeByAndCid(make).subscribe(
      (res: any) => {
        console.log('Make Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Make Error:', err);
      }
    );
  }

  getAllObjectInfoByTypeWithPagination(type: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "type": type,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllObjectInfoByTypeWithPagination(body).subscribe(
      (res: any) => {
        console.log('type Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllByType(type: any) {
    this.generic_service.getAllByType(type).subscribe(
      (res: any) => {
        console.log('Type Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Type Error:', err);
      }
    );
  }


  getAllObjectsByLockAndCidWithPagination(lock: any, pageNumber: any, recordsPerPage: any) {


    const body: any = {
      "lock": lock,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllObjectsByLockAndCidWithPagination(body).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllObjectsByLockAndCid(lock: any) {


    this.generic_service.getAllObjectsByLockAndCid(lock).subscribe(
      (res: any) => {
        console.log('lock Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }

        if (lock) {
          this.isUnLockAll = true
          this.isLockAll = false
          this.isShowLock = true
        } else {
          this.isLockAll = true
          this.isUnLockAll = false
          this.isShowLock = true
        }

        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Error:', err);
      }
    );
  }



  getAllByLocationAndCidWithPagination(location: any, pageNumber: any, recordsPerPage: any) {


    // const body: any = {
    //   "version": 0,
    //   "isActive": true,
    //   "description": "",
    //   "location": this.userLocations || [],
    //   "cid": this.cid,
    //   "pageNo": pageNumber,
    //   "recordsPerPage": recordsPerPage
    // }

    this.generic_service.getAllByLocationAndCidWithPagination(location, pageNumber, recordsPerPage).subscribe(
      (res: any) => {
        console.log('location Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('location Error:', err);
      }
    );
  }

  getAllByLocationAndCid(location: any) {
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('location Error:', err);
      }
    );
  }



  getAllBySerialNumberAndCidWithPagination(serialNumber: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "serialNumber": serialNumber,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllBySerialNumberAndCidWithPagination(body).subscribe(
      (res: any) => {
        console.log('serialNumber Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('serialNumber Error:', err);
      }
    );
  }



  getAllBySerialNumberAndCid(serialNumber: any) {
    this.generic_service.getAllBySerialNumberAndCid(serialNumber).subscribe(
      (res: any) => {
        console.log('Serial Number Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  getAllByObjectConditionAndCidWithPagination(condition: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "condition": condition,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllByObjectConditionAndCidWithPagination(body).subscribe(
      (res: any) => {
        console.log('condition Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('condition Error:', err);
      }
    );
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    this.generic_service.getAllByObjectConditionAndCid(objectCondition).subscribe(
      (res: any) => {
        console.log('Object Condition Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Object Condition Error:', err);
      }
    );
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        this.uomData = res.response
      }
    )
  }



  getAllByBranchAndCidWithPagination(branch: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "branch": branch,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllByBranchAndCidWithPagination(body).subscribe(
      (res: any) => {
        console.log('branch Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('branch Error:', err);
      }
    );
  }

  getAllByBranchAndCid(branch: any) {
    this.generic_service.getAllByBranchAndCid(branch).subscribe(
      (res: any) => {
        console.log('Branch Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Branch Error:', err);
      }
    );
  }


  getAllByDepartmentAndCidWithPagination(department: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "department": department,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }

    this.generic_service.getAllByDepartmentAndCidWithPagination(body).subscribe(
      (res: any) => {
        console.log('department Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('department Error:', err);
      }
    );
  }

  getAllByDepartmentAndCid(department: any) {
    this.generic_service.getAllByDepartmentAndCid(department).subscribe(
      (res: any) => {
        console.log('Department Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Department Error:', err);
      }
    );
  }

  getAllObjectInfoByGroupWithPagination(group: any, pageNumber: any, recordsPerPage: any) {

    const body: any = {
      "group": group,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }
    this.generic_service.getAllObjectInfoByGroupWithPagination(body).subscribe(
      (res: any) => {
        console.log('group Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.count = 0
          return
        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('group Error:', err);
      }
    );
  }


  getAllByGroup(group: any) {
    this.generic_service.getAllByGroup(group).subscribe(
      (res: any) => {
        console.log('Group Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Group Error:', err);
      }
    );
  }

  getAllObjectInfoByGroupAndType(group: any, type: any) {
    this.generic_service.getAllObjectInfoByGroupAndType(group, type).subscribe(
      (res: any) => {
        console.log('Group and Type Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
      },
      (err: any) => {
        console.log('Group and Type Error:', err);
      }
    );
  }

  getAllTypeList() {
    this.generic_service.getAllTypeList().subscribe(
      (res: any) => {
        this.objectTypeData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllGroupList() {
    this.generic_service.getAllGroupList().subscribe(
      (res: any) => {
        this.objectGroupData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  selectedFilter: any = ""

  modelChecked = false;
  modelFilter = "";

  locationChecked = false;
  locationFilter = "";

  lockChecked = false;
  lockFilter = "";

  makeChecked = false;
  makeFilter = "";

  typeChecked = false;
  typeFilter = "";

  serialNumberChecked = false;
  serialNumberFilter = "";

  objectConditionChecked = false;
  objectConditionFilter = "";

  branchChecked = false;
  branchFilter = "";

  departmentChecked = false;
  departmentFilter = "";

  groupChecked = false;
  groupFilter = "";

  parentAssetChecked = false;
  parentAssetFilter = "";

  onFilterSelect(selected: string) {
    console.log(selected)



    this.modelChecked = false
    this.makeChecked = false
    this.typeChecked = false
    this.serialNumberChecked = false
    this.objectConditionChecked = false
    this.branchChecked = false
    this.departmentChecked = false
    this.parentAssetChecked = false;
    this.groupChecked = false
    this.locationChecked = false
    this.lockChecked = false
    this.selectedFilter = selected



    if (selected == "modelFilter") {
      this.modelChecked = true
    }

    if (selected == "makeFilter") {
      this.makeChecked = true
    }

    if (selected == "typeFilter") {
      this.typeChecked = true
    }

    if (selected == "serialNumberFilter") {
      this.serialNumberChecked = true
    }

    if (selected == "objectConditionFilter") {
      this.objectConditionChecked = true
    }

    if (selected == "branchFilter") {
      this.branchChecked = true
    }

    if (selected == "departmentFilter") {
      this.departmentChecked = true
    }

    if (selected == "parentAssetFilter") {
      this.parentAssetChecked = true
    }

    if (selected == "groupFilter") {
      this.groupChecked = true
    }

    if (selected == "locationFilter") {
      this.locationChecked = true
    }

    if (selected == "lockFilter") {
      this.lockChecked = true
    }

  }

  resetFilter() {
    this.page = 0
    this.first = 0
    this.selectedFilter = ""

    this.modelFilter = "";
    this.locationFilter = "";
    this.makeFilter = "";
    this.typeFilter = "";
    this.serialNumberFilter = "";
    this.objectConditionFilter = "";
    this.branchFilter = "";
    this.departmentFilter = "";
    this.parentAssetFilter = ""
    this.groupFilter = "";

    this.modelChecked = false;
    this.makeChecked = false;
    this.typeChecked = false;
    this.groupChecked = false;
    this.serialNumberChecked = false;
    this.objectConditionChecked = false;
    this.branchChecked = false;
    this.locationChecked = false;
    this.lockChecked = false
    this.departmentChecked = false;
    this.parentAssetChecked = false;
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false
    this.getAllObjectInfo()
    this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);

  }

  applyFilter() {
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false

    if (this.modelChecked) {
      this.getAllModelByAndCid(this.modelFilter);
      this.getAllModelByAndCidWIthPagination(this.modelFilter, this.page, this.recordsPerPage)
    }

    if (this.makeChecked) {
      console.log(this.make)
      this.getAllMakeByAndCid(this.makeFilter);
      this.getAllMakeByAndCidWIthPagination(this.makeFilter, this.page, this.recordsPerPage)

    }

    if (this.typeChecked) {
      this.getAllByType(this.typeFilter);
      this.getAllObjectInfoByTypeWithPagination(this.typeFilter, this.page, this.recordsPerPage)

    }

    if (this.serialNumberChecked) {
      this.getAllBySerialNumberAndCid(this.serialNumberFilter);
      this.getAllBySerialNumberAndCidWithPagination(this.serialNumberFilter, this.page, this.recordsPerPage)

    }

    if (this.objectConditionChecked) {
      this.getAllByObjectConditionAndCid(this.objectConditionFilter);
      this.getAllByObjectConditionAndCidWithPagination(this.objectConditionFilter, this.page, this.recordsPerPage)

    }

    if (this.branchChecked) {
      this.getAllByBranchAndCid(this.branchFilter);
      this.getAllByBranchAndCidWithPagination(this.branchFilter, this.page, this.recordsPerPage)

    }

    if (this.departmentChecked) {
      this.getAllByDepartmentAndCid(this.departmentFilter);
      this.getAllByDepartmentAndCidWithPagination(this.departmentFilter, this.page, this.recordsPerPage)

    }

    if (this.parentAssetChecked) {
      this.getParentsFromList(this.parentAssetFilter);
      this.getObjectInfoByParentAssetIdWithPagination(this.parentAssetFilter, this.page, this.recordsPerPage)

    }

    if (this.groupChecked) {
      this.getAllByGroup(this.groupFilter);
      this.getAllObjectInfoByGroupWithPagination(this.groupFilter, this.page, this.recordsPerPage)

    }

    if (this.locationChecked) {
      this.getAllByLocationAndCid(this.locationFilter);
      this.getAllByLocationAndCidWithPagination(this.locationFilter, this.page, this.recordsPerPage)

    }

    if (this.lockChecked) {
      this.getAllObjectsByLockAndCid(this.lockFilter);
      this.getAllObjectsByLockAndCidWithPagination(this.lockFilter, this.page, this.recordsPerPage)

    }


  }

  removeImage(index: any) {
    this.imagesWithDetails.splice(index, 1)
    this.updateObjectImagesUpdateRequest()
  }

  addTicketImageBtn() {
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(this.file.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      return;
    }

    this.onTicketUpload()
  }



  addProofBtn() {
    document.getElementById("add-proof-btn")?.click()
  }

  onProofChange(event: any) {
    this.file = event.target.files[0];

    // const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    // if (!validTypes.includes(this.file.type)) {
    //   this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
    //   return;
    // }
    this.onUploadProof()
  }


  onUploadProof() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      for (let list of this.singleObjectTemplateData[0]?.warrantyInfo) {
        if (list.key == 'Proof Of Purchase (Scan and Upload Bill or invoice etc)') {
          list.value = event.response
        }
        this.proofFile = this.file.name
        this.proofFilePath = event.response
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

        if (validTypes.includes(this.file.type)) {
          this.proofFileType = this.file.type
        }
        console.log(this.proofFileType)
      }
      console.log(this.singleObjectTemplateData[0]?.warrantyInfo)
      // this.imagesList.push(event.response)
    });
  }




  addTicketImageBtn1() {
    document.getElementById("add-TicketImage-btn1")?.click()
  }

  onTicketChange1(event: any) {
    this.file = event.target.files[0];

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(this.file.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      return;
    }
    this.onUploadAsset()
  }


  onUploadAsset() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.imagesList.push(event.response)
      let obj = {
        "image": event.response,
        "name": this.file.name,
        "type": this.file.type
      }
      console.log(this.imagesWithDetails)
      this.imagesWithDetails.push(obj)
      this.updateObjectImagesUpdateRequest()
    });
  }

  updateObjectImagesUpdateRequest() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "imagesList": this.imagesList,
      "imagesWithDetails": this.imagesWithDetails,
      "cid": Number(this.cid),
      "objectInfoId": this.objectInfoId
    }
    console.log(body)
    this.generic_service.updateObjectImagesUpdateRequest(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectInfo()
        this.getAllObjectInfoWithPaginationAndLocation(this.page, this.recordsPerPage);
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }

  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.imagesList.push(event.response)
      let obj = {
        "image": event.response,
        "name": this.file.name,
        "type": this.file.type
      }
      this.imagesWithDetails.push(obj)
    });
  }

  selectLargeImage(largeImage: any) {
    this.largeImage = largeImage
  }


  addIconBtn() {
    document.getElementById("add-icon-btn")?.click()
  }

  onIconChange(event: any) {
    this.iconFile = event.target.files[0];
    this.onUploadIcon()
  }

  removeIcon() {
    this.icon = ""
  }

  onUploadIcon() {
    this.generic_service.uploadImage(this.iconFile).subscribe((event: any) => {
      console.log(event);
      this.icon = event.response
    });
  }


  selectConnection(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.assetMonitoring = true
      this.assetMonitoringFrequency = 0
      this.assetMonitoringTimeSpan = 0
      this.connectionsList = []
      this.addConnection()
      this.host = ""
      this.name = ""
      this.groups = []
      this.templates = []
      this.ip = ""
      this.port = 0
      this.snmpCommunity = ""
      this.snmpVersion = 0
      this.snmpContextName = ""
    } else {
      this.assetMonitoringFrequency = 0
      this.assetMonitoringTimeSpan = 0
      this.assetMonitoring = false
      this.connectionsList = []
      this.host = ""
      this.name = ""
      this.groups = []
      this.templates = []
      this.ip = ""
      this.port = 0
      this.snmpCommunity = ""
      this.snmpVersion = 0
      this.snmpContextName = ""
    }
  }

  addConnection() {
    this.connectionsList.push({
      "key": "",
      "value": "",
    })
  }

  removeConnection(index: number) {
    this.connectionsList.splice(index, 1)
  }

  selectAssetHealth(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.assetHealth = true
      this.assetHealthList = []
      this.addAssetHealth()
    } else {
      this.assetHealth = false
      this.assetHealthList = []
    }
  }

  selectPerformance(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.performance = true
      this.timeSpan = ""
      this.expectedOutput = ""
      this.uom = ""
    } else {
      this.performance = false
      this.timeSpan = ""
      this.expectedOutput = ""
      this.uom = ""
    }
  }



  selectParentAsset(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.isParentAssetId = true
      this.parentAssetId = 0
    } else {
      this.isParentAssetId = false
      this.parentAssetId = 0
    }
  }



  addAssetHealth() {
    this.assetHealthList.push({
      "key": "",
      "value": "",
    })
  }

  removeAssetHealth(index: number) {
    this.assetHealthList.splice(index, 1)
  }



  filterInputByType(event: KeyboardEvent, inputType: 'number' | 'onlyText' | 'allText'): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Always allow control keys (e.g., backspace, arrows, delete, tab, etc.)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key)) {
      return true;
    }

    if (key === 'Enter') {
      return true;
    }

    switch (inputType) {
      case 'number':
        // Allow digits only
        if (!/^\d$/.test(key)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'onlyText':
        // Allow letters and space (not as first character, and no double space)
        if (!/^[a-zA-Z ]$/.test(key)) {
          event.preventDefault();
          return false;
        }
        if (key === ' ') {
          const selectionStart = inputElement.selectionStart;
          const charBefore = selectionStart !== null && selectionStart > 0 ? currentValue[selectionStart - 1] : '';
          const charAfter = selectionStart !== null && selectionStart < currentValue.length ? currentValue[selectionStart] : '';

          if (charBefore === ' ' || charAfter === ' ' || selectionStart === 0) {
            event.preventDefault();
            return false;
          }
        }
        break;

      case 'allText':
        // Allow all characters, but disallow space as first character or double space
        if (key === ' ') {
          const selectionStart = inputElement.selectionStart;
          const charBefore = selectionStart !== null && selectionStart > 0 ? currentValue[selectionStart - 1] : '';
          const charAfter = selectionStart !== null && selectionStart < currentValue.length ? currentValue[selectionStart] : '';

          if (charBefore === ' ' || charAfter === ' ' || selectionStart === 0) {
            event.preventDefault();
            return false;
          }
        }
        break;

      default:
        event.preventDefault();
        return false;
    }

    return true;
  }

  trimValue(field: string) {
    if (this[field as keyof this]) {
      if (typeof this[field as keyof this] === 'string') {
        (this[field as keyof this] as any) = (this[field as keyof this] as any).trim();
      }
    }
  }

  removeFile(fileInput: HTMLInputElement) {
    fileInput.value = '';
    this.file = ''
  }



  getObjectInfoByWildSearchWithPagination(pageNumber: any, recordsPerPage: any) {
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false
    this.showFilter = false

    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }

    const body: any = {
      "wildSearch": this.searchFilter,
      "location": this.userLocations || [],
      "cid": this.cid,
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage
    }
    this.generic_service.getObjectInfoByWildSearchWithPagination(body).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoListWithPagination = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoListWithPagination = res.response.objectInfoList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  getObjectInfoByWildSearch() {
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false
    this.showFilter = false

    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  openMapPopup(): void {

    setTimeout(() => {
      this.initMap();
      this.map.invalidateSize();
    }, 500);
  }

  openMapPopup1(): void {

    setTimeout(() => {
      this.initMap1();
      this.map.invalidateSize();
    }, 500);
  }

  openMapPopup2(): void {

    setTimeout(() => {
      this.initMap2();
      this.map.invalidateSize();
      if (this.location) {
        this.locationChange(this.location, true);
      }
    }, 500);
  }

  openMapPopup3(): void {

    setTimeout(() => {
      this.initMap3();
      this.map.invalidateSize();
    }, 500);
  }


  marker!: L.Marker;

  initMap(): void {
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    });

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      this.placeMarker(event.latlng);
    });

    tiles.addTo(this.map);
  }

  initMap1(): void {
    if (this.isLatLng && this.latlng) {
      this.defaultCenter = [this.latlng.lat, this.latlng.lng];
      console.log(this.defaultCenter);
    }

    this.map = L.map('map1', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      if (!this.multiLatLng) {
        this.placeMarker(event.latlng);
      }
    });

    if (this.isLatLng && this.latlng) {
      this.marker = L.marker([this.latlng.lat, this.latlng.lng]).addTo(this.map);
    }

    // ✅ Initialize drawnItems as editable layer group
    this.drawnItems = L.featureGroup().addTo(this.map);

    // ✅ Add draw control (only edit existing, no new shapes)
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems,
        remove: false // ❌ Disable deletion if needed
      },
      draw: {
        marker: false,
        polygon: false,
        polyline: false, // ✅ Prevent drawing new lines
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.map.addControl(drawControl);

    // ✅ Load GeoJSON and make it editable
    const multiLatLng = this.singleObjectInfoData?.[0]?.multiLatLng;
    const area = this.area;
    console.log(multiLatLng)
    console.log(area)
    if (multiLatLng && area.length > 0) {
      const coordinates: [number, number][] = area.map((point: any) => [
        parseFloat(point.lng),
        parseFloat(point.lat)
      ]);

      this.geojsonData = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: { name: 'Polygon' },
            geometry: {
              type: 'LineString',
              coordinates: coordinates
            }
          }
        ]
      };

      const geojsonLayer = L.geoJSON(this.geojsonData, {
        color: this.singleObjectInfoData?.[0]?.objectColorCode || "black",
        weight: 7
      });

      if (coordinates && coordinates.length != 0) {
        this.isObjectColorCode = true
      } else {
        this.isObjectColorCode = false
      }

      // ✅ Add to drawnItems to make editable
      geojsonLayer.eachLayer((layer: Layer) => {
        this.drawnItems.addLayer(layer);
      });

      // ✅ Center map on editable shapes
      this.map.fitBounds(this.drawnItems.getBounds());
    }

    // ✅ Listen to edit events
    this.map.on(L.Draw.Event.EDITED, (e: any) => {
      const layers = e.layers;
      layers.eachLayer((layer: any) => {
        const updatedGeoJSON = layer.toGeoJSON();

        // ✅ Convert coordinates back to your API format
        const updatedCoords = updatedGeoJSON.geometry.coordinates.map(
          (coord: [number, number]) => ({
            lat: coord[1].toFixed(8),
            lng: coord[0].toFixed(8)
          })
        );

        this.updatedCoords = updatedCoords
        this.area = updatedCoords
        console.log('✅ Updated Coordinates:', updatedCoords);

        // TODO: Save updatedCoords to your backend via API
        // this.saveUpdatedArea(updatedCoords);
      });
    });
  }

  drawnItems!: L.FeatureGroup;



  initMap2(): void {
    if (this.isLatLng && this.latlng) {
      this.defaultCenter = [this.latlng.lat, this.latlng.lng];
      console.log(this.defaultCenter);
    }

    this.map = L.map('map2', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      if (!this.multiLatLng) {
        this.placeMarker(event.latlng);
      }
    });

    if (this.isLatLng && this.latlng) {
      this.marker = L.marker([this.latlng.lat, this.latlng.lng]).addTo(this.map);
    }

    // ✅ Initialize drawnItems as editable layer group
    this.drawnItems = L.featureGroup().addTo(this.map);

    // ✅ Add draw control (only edit existing, no new shapes)
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems,
        remove: false // ❌ Disable deletion if needed
      },
      draw: {
        marker: false,
        polygon: false,
        polyline: false, // ✅ Prevent drawing new lines
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.map.addControl(drawControl);

    // ✅ Load GeoJSON and make it editable
    const multiLatLng = this.singleObjectInfoData?.[0]?.multiLatLng;
    const area = this.area;
    console.log(multiLatLng)
    console.log(area)
    if (multiLatLng && area.length > 0) {
      const coordinates: [number, number][] = area.map((point: any) => [
        parseFloat(point.lng),
        parseFloat(point.lat)
      ]);

      this.geojsonData = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: { name: 'Polygon' },
            geometry: {
              type: 'LineString',
              coordinates: coordinates
            }
          }
        ]
      };

      const geojsonLayer = L.geoJSON(this.geojsonData, {
        color: this.singleObjectInfoData?.[0]?.objectColorCode || "black",
        weight: 7
      });

      if (coordinates && coordinates.length != 0) {
        this.isObjectColorCode = true
      } else {
        this.isObjectColorCode = false
      }

      // ✅ Add to drawnItems to make editable
      geojsonLayer.eachLayer((layer: Layer) => {
        this.drawnItems.addLayer(layer);
      });

      // ✅ Center map on editable shapes
      this.map.fitBounds(this.drawnItems.getBounds());
    }

    // ✅ Listen to edit events
    this.map.on(L.Draw.Event.EDITED, (e: any) => {
      const layers = e.layers;
      layers.eachLayer((layer: any) => {
        const updatedGeoJSON = layer.toGeoJSON();

        // ✅ Convert coordinates back to your API format
        const updatedCoords = updatedGeoJSON.geometry.coordinates.map(
          (coord: [number, number]) => ({
            lat: coord[1].toFixed(8),
            lng: coord[0].toFixed(8)
          })
        );

        this.updatedCoords = updatedCoords
        this.area = updatedCoords
        console.log('✅ Updated Coordinates:', updatedCoords);

        // TODO: Save updatedCoords to your backend via API
        // this.saveUpdatedArea(updatedCoords);
      });
    });
  }

  initMap3(): void {
    if (this.isLatLng && this.latlng) {
      this.defaultCenter = [this.latlng.lat, this.latlng.lng];
      console.log(this.defaultCenter);
    }

    this.map = L.map('map3', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);


    if (!this.singleObjectInfoData?.[0]?.quantityCheckBox) {
      if (this.isLatLng && this.latlng) {
        this.marker = L.marker([this.latlng.lat, this.latlng.lng]).addTo(this.map);
      }
    }



    // ✅ Load GeoJSON and make it editable
    const multiLatLng = this.singleObjectInfoData?.[0]?.multiLatLng;
    const area = this.area;
    // if (multiLatLng && area.length > 0) {
    //   const coordinates: [number, number][] = area.map((point: any) => [
    //     parseFloat(point.lng),
    //     parseFloat(point.lat)
    //   ]);

    //   this.geojsonData = {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         properties: { name: 'Polygon' },
    //         geometry: {
    //           type: 'LineString',
    //           coordinates: coordinates
    //         }
    //       }
    //     ]
    //   };

    //   const geojsonLayer = L.geoJSON(this.geojsonData, {
    //     color: this.singleObjectInfoData?.[0]?.objectColorCode || "black",
    //     weight: 7
    //   });

    //   if(coordinates && coordinates.length != 0){
    //     this.isObjectColorCode = true
    //   }else{
    //     this.isObjectColorCode = false
    //   }

    //   // ✅ Add to drawnItems to make editable
    //   geojsonLayer.eachLayer((layer: Layer) => {
    //     this.drawnItems.addLayer(layer);
    //   });

    //   // ✅ Center map on editable shapes
    //   this.map.fitBounds(this.drawnItems.getBounds());
    // }


    this.geojsonData = {
      type: 'FeatureCollection',
      features: []
    };

    console.log(this.assetRolloutData)

    for (let list of this.assetRolloutData) {
      if (list.area && list.area.length > 0) {
        const latlngs = list.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
        const feature = {
          type: "Feature",
          color: 'black',
          properties: list,
          geometry: {
            type: "LineString",
            coordinates: latlngs
          }
        };
        this.geojsonData.features.push(feature);
      }

    }


    console.log(this.geojsonData)


    if (this.geojsonData?.features?.length) {

      const geoJsonLayer = L.geoJSON(this.geojsonData, {
        style: (feature: any) => ({
          color: feature.color || 'black',
          weight: 7
        })
      }).addTo(this.map);

      this.map.fitBounds(geoJsonLayer.getBounds(), {
        padding: [20, 20]
      });
    }





    // ✅ Listen to edit events
    this.map.on(L.Draw.Event.EDITED, (e: any) => {
      const layers = e.layers;
      layers.eachLayer((layer: any) => {
        const updatedGeoJSON = layer.toGeoJSON();

        // ✅ Convert coordinates back to your API format
        const updatedCoords = updatedGeoJSON.geometry.coordinates.map(
          (coord: [number, number]) => ({
            lat: coord[1].toFixed(8),
            lng: coord[0].toFixed(8)
          })
        );

        this.updatedCoords = updatedCoords
        this.area = updatedCoords
        console.log('✅ Updated Coordinates:', updatedCoords);

        // TODO: Save updatedCoords to your backend via API
        // this.saveUpdatedArea(updatedCoords);
      });
    });
  }


  mapCenter() {
    this.map.remove();
    this.singleObjectInfoData = []
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        this.map.setView(this.defaultCenter, this.map.getZoom());
      }
    }, 500);
    this.initMap2()

  }

  isPointInsidePolygon(point: L.LatLng, poly: any): boolean {
    let latlngs = poly.getLatLngs();
    while (latlngs.length > 0 && Array.isArray(latlngs[0])) {
      latlngs = latlngs[0] as any;
    }
    let points = latlngs as any as L.LatLng[];

    let x = point.lat, y = point.lng;
    let inside = false;
    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      let xi = points[i].lat, yi = points[i].lng;
      let xj = points[j].lat, yj = points[j].lng;
      let intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  placeMarker(latlng: L.LatLng): void {
    console.log(latlng)

    let polygonExists = false;
    let isInside = false;

    if (this.drawnItems && this.drawnItems.getLayers().length > 0) {
      this.drawnItems.getLayers().forEach((layer: any) => {
        if (layer instanceof L.Polygon) {
          polygonExists = true;
          if (this.isPointInsidePolygon(latlng, layer)) {
            isInside = true;
          }
        }
      });
    }

    if (!polygonExists && (this as any).locationPolygon) {
      polygonExists = true;
      if (this.isPointInsidePolygon(latlng, (this as any).locationPolygon)) {
        isInside = true;
      }
    }

    if (polygonExists && !isInside) {
      this.toastr.error("Please mark inside the area");
      return;
    }

    this.isLatLng = true

    // Remove existing marker if needed
    this.latlng = latlng
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    // Create new marker
    this.marker = L.marker(latlng)
      .addTo(this.map)
    // .bindPopup(`📍 You clicked here:<br>Lat: ${latlng.lat.toFixed(5)}, Lng: ${latlng.lng.toFixed(5)}`)
    // .openPopup();
  }

  removeLatLng() {
    this.isLatLng = false
    this.latlng = {}
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
  }

  geojsonLayer!: L.GeoJSON; // Add this to your component class

  resetEditLatLng() {
    this.latlng = {};

    // Remove existing marker
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    // ❌ THIS was incorrect: this.geojsonData is not a Leaflet layer
    // ✅ Correct: remove actual geojsonLayer from map
    if (this.geojsonLayer) {
      this.map.removeLayer(this.geojsonLayer);
    }

    // Clear drawnItems if needed
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }

    // Add marker
    if (this.singleObjectInfoData[0].lat && this.singleObjectInfoData[0].lat != 0 && this.singleObjectInfoData[0].lat != null) {
      this.latlng.lat = this.singleObjectInfoData[0].lat;
      this.latlng.lng = this.singleObjectInfoData[0].lng;
      this.isLatLng = true;

      let latlng = L.latLng(this.latlng.lat, this.latlng.lng);
      this.placeMarker(latlng);
      this.map.setView(latlng, this.map.getZoom());
    }

    // Add polyline (LineString)
    if (this.singleObjectInfoData[0].area && this.singleObjectInfoData[0].area.length !== 0) {
      const area = this.singleObjectInfoData[0].area;

      const coordinates: [number, number][] = area.map((point: any) => [
        parseFloat(point.lng),
        parseFloat(point.lat)
      ]);

      this.geojsonData = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: { name: 'Polygon' },
            geometry: {
              type: 'LineString',
              coordinates: coordinates
            }
          }
        ]
      };

      // ✅ Store geojson layer reference
      this.geojsonLayer = L.geoJSON(this.geojsonData, {
        style: {
          color: 'black',
          weight: 4
        }
      });

      this.geojsonLayer.eachLayer((layer: L.Layer) => {
        this.drawnItems.addLayer(layer);
      });

      this.map.fitBounds(this.drawnItems.getBounds());
    }
  }



  filterDateInput(event: any): boolean {

    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Allow control keys (navigation, editing)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
      'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key) || key === 'Enter') {
      return true;
    }

    // Allow only digits and slashes
    if (!/[\d/]/.test(key)) {
      event.preventDefault();
      return false;
    }

    console.log(event.target.value)

    if (currentValue != null && currentValue != '' && currentValue != undefined) {
      if (currentValue.length > 9) {
        console.log(currentValue)
        console.log("ok")
        const date = new Date(currentValue);

        const year: any = date.getFullYear();
        console.log('Year:', year);

        if (year > 999) {
          console.log(typeof year)
          event.preventDefault();
          return false;
        }

      }
    }

    return true;
  }

  assetLock: any = []

  selectAssetForLock(objectInfoId: any) {
    this.assetLock.push(objectInfoId)
  }

  bulkUpdateObjectInfoLocking(locking: any) {


    let lockingFiles: any = []

    for (let list of this.objectInfoList) {
      if (list.lock == locking) {
        let obj = {
          "version": 0,
          "isActive": true,
          "description": "",
          "objectInfoId": list.objectInfoId,
          "locking": locking,
          "cid": list.cid
        }
        lockingFiles.push(obj)
      }
    }

    if (lockingFiles.length == 0) {
      return
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "lockingFiles": lockingFiles
    }

    console.log(body)
    this.generic_service.updateObjectInfoLocking(body).subscribe(
      (response: any) => {
        this.loadData()
        this.toastr.success(response.message)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


  updateObjectInfoLocking(locking: any) {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "lockingFiles": [
        {
          "version": 0,
          "isActive": true,
          "description": "",
          "objectInfoId": this.singleObjectInfoData[0].objectInfoId,
          "locking": locking,
          "cid": this.singleObjectInfoData[0].cid
        }
      ]
    }

    console.log(body)
    this.generic_service.updateObjectInfoLocking(body).subscribe(
      (response: any) => {
        this.getObjectInfoById(this.singleObjectInfoData[0].objectInfoId, 'view')
        this.loadData()
        this.toastr.success(response.message)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  updateObjectAliveRequest(alive: any) {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "lockingFiles": [
        {
          "version": 0,
          "isActive": true,
          "description": "",
          "objectInfoId": this.singleObjectInfoData[0].objectInfoId,
          "locking": alive,
          "cid": this.singleObjectInfoData[0].cid
        }
      ]
    }

    console.log(body)
    this.generic_service.updateObjectAliveRequest(body).subscribe(
      (response: any) => {
        this.getObjectInfoById(this.singleObjectInfoData[0].objectInfoId)
        this.loadData()
        this.toastr.success(response.message)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }



  getAllAssetStatus() {
    this.generic_service.getAllAssetStatus().subscribe(
      (res: any) => {
        this.assetStatusList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  objectConditionChange() {
    if (this.objectCondition == "Good") {
      this.assetStatus = "installed/deployed"
    }

    if (this.objectCondition == "UnderRepair") {
      this.assetStatus = "under repair"
    }
  }





  printDiv1(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;
    if (!printContents) return;

    const popupWin = window.open('', '', 'width=500,height=400');
    popupWin?.document.open();
    popupWin?.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        ${printContents}
      </body>
    </html>
  `);
    // popupWin?.document.close();
  }


  printDiv11(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;
    if (!printContents) return;

    const popupWin = window.open('', '_blank', 'width=400,height=400');
    popupWin?.document.open();
    popupWin?.document.write(`
      <html>
        <head>
          <title>Print Label</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 14px;
              padding: 10px;
            }
            .print-data p {
              margin: 0;
              padding: 0;
            }
            qrcode, img {
              display: block;
              margin-top: 10px;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
    // popupWin?.document.close();
  }


  printDiv(divId: string) {
    const divToPrint = document.getElementById(divId);
    if (!divToPrint) return;

    const newWin = window.open('', '_blank', 'width=400,height=400');
    if (!newWin) return;

    newWin.document.open();
    newWin.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 10px;
          }
          .print-data p {
            margin: 0;
          }
          img, canvas {
            display: block;
            margin-top: 10px;
          }
        </style>
      </head>
      <body>
      </body>
    </html>
  `);

    // Append the actual DOM node instead of innerHTML
    const cloned = divToPrint.cloneNode(true);
    newWin.document.body.appendChild(cloned);
    // newWin.document.close();

    // Give QR code time to render if it's async
    setTimeout(() => {
      newWin.print();
      // newWin.close();
    }, 1500);
  }

  async autoPrint() {
    const element = document.getElementById('print-section');
    if (!element) return;

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    pdf.addImage(imgData, 'PNG', 10, 10, 80, 80);
    const pdfBase64 = btoa(pdf.output());


  }


  printDiv2(divName: string) {
    const printContents = document.getElementById(divName)?.innerHTML;
    const originalContents = document.body.innerHTML;

    if (printContents) {
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // Optional: to restore Angular bindings
    }
  }

  print23(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;
    if (!printContents) return;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);
      doc.close();
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    }

    setTimeout(() => document.body.removeChild(iframe), 1000);
  }


  print121(divId: string) {
    const sourceElement = document.getElementById(divId);
    if (!sourceElement) return;

    // Wait for QRCode to finish rendering before printing
    setTimeout(() => {
      const printContents = sourceElement.innerHTML;
      const iframe = document.createElement('iframe');

      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';

      document.body.appendChild(iframe);
      const doc = iframe.contentWindow?.document;

      if (doc) {
        doc.open();
        doc.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              .print-section-block {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 20px;
              }
              .print-data p {
                margin: 4px 0;
              }
            </style>
          </head>
          <body>
            ${printContents}
          </body>
        </html>
      `);
        doc.close();

        // Wait for QR image/canvas to render before printing
        iframe.onload = () => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          setTimeout(() => document.body.removeChild(iframe), 500);
        };
      }
    }, 300); // small delay ensures <qrcode> finishes rendering
  }



  print122(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;
    if (!printContents) return;

    // Create a temporary container at the top of body
    const originalBody = document.body.innerHTML;
    document.body.innerHTML = `<div>${printContents}</div>`;

    // Trigger print
    window.print();

    // Restore original body
    document.body.innerHTML = originalBody;
    // Optional: re-bootstrap modal back if needed
    window.location.reload(); // simple way to restore modal state
  }


  print5(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;
    if (!printContents) return;

    const popupWin = window.open('', '_blank', 'width=800,height=600');
    popupWin?.document.open();
    popupWin?.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          /* optional: include your styles */
        </style>
      </head>
      <body onload="window.print();window.close()">
        ${printContents}
      </body>
    </html>
  `);
  }



  @ViewChild('printContainer') printContainer!: ElementRef;

  printDiv5555s(divId: string) {
    const divToPrint = document.getElementById(divId);
    if (!divToPrint) return;

    // Hide all other elements
    const bodyChildren = Array.from(document.body.children) as HTMLElement[];
    bodyChildren.forEach(el => {
      if (!divToPrint.contains(el) && el.id !== divId) {
        el.style.display = 'none';
      }
    });

    // Trigger print
    window.print();

    // Restore all elements
    bodyChildren.forEach(el => (el.style.display = ''));
  }









  print(divId: string) {
    const sourceElement = document.getElementById(divId);
    if (!sourceElement) {
      console.warn('print: element not found', divId);
      return;
    }

    // Wait for Angular to stabilize (ensures <qrcode> rendered)
    this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
      try {
        // 1) Try to find a canvas inside the print section (angularx-qrcode often renders canvas)
        const canvas: HTMLCanvasElement | null = sourceElement.querySelector('canvas');
        if (canvas) {
          const dataUrl = canvas.toDataURL('image/png');
          this.printWithImageHtml(sourceElement, dataUrl);
          return;
        }

        // 2) Try to find an img inside the print section (some QR components render <img>)
        const imgEl: HTMLImageElement | null = sourceElement.querySelector('img');
        if (imgEl && imgEl.src) {
          // if it's a data URL or regular src, use it
          this.printWithImageHtml(sourceElement, imgEl.src);
          return;
        }

        // 3) If neither found, attempt to convert inline SVG (if any) to PNG
        const svgEl: SVGElement | null = sourceElement.querySelector('svg');
        if (svgEl) {
          const svgString = new XMLSerializer().serializeToString(svgEl);
          const svgBase64 = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
          this.convertSvgToPngAndPrint(svgBase64, sourceElement);
          return;
        }

        // 4) Last fallback: clone the HTML and print (not guaranteed if QR requires Angular)
        this.printWithHtmlClone(sourceElement.innerHTML);
      } catch (err) {
        console.error('print error', err);
        this.printWithHtmlClone(sourceElement.innerHTML);
      }
    });
  }

  /** create iframe document that embeds the QR image dataUrl */
  private printWithImageHtml(sourceElement: HTMLElement, imageDataUrl: string) {
    // create a shallow copy of textual fields (to preserve dynamic text)
    // We'll replace any <qrcode> element with an <img>
    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = sourceElement.innerHTML;

    // replace qrcode element(s) with <img>
    const qrcodeElems = Array.from(tempWrapper.querySelectorAll('qrcode'));
    if (qrcodeElems.length) {
      qrcodeElems.forEach(q => {
        const img = document.createElement('img');
        img.src = imageDataUrl;
        img.width = 150; // match your width
        // replace the qrcode tag with the img
        q.parentNode?.replaceChild(img, q);
      });
    } else {
      // If there was no <qrcode>, but there was canvas/img, try replacing canvas/img nodes
      const canv = tempWrapper.querySelector('canvas');
      if (canv) {
        const img = document.createElement('img');
        img.src = imageDataUrl;
        img.width = 150;
        canv.parentNode?.replaceChild(img, canv);
      }
    }

    // Now print the prepared HTML
    this.createIframeAndPrint(tempWrapper.innerHTML);
  }

  /** convert an SVG data url to PNG using an offscreen canvas and then print */
  private convertSvgToPngAndPrint(svgDataUrl: string, sourceElement: HTMLElement) {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width || 300;
      canvas.height = img.height || 300;
      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(img, 0, 0);
      const pngDataUrl = canvas.toDataURL('image/png');
      this.printWithImageHtml(sourceElement, pngDataUrl);
    };
    img.onerror = () => {
      // fallback
      this.printWithHtmlClone(sourceElement.innerHTML);
    };
    img.src = svgDataUrl;
  }

  /** fallback that simply clones HTML (works if <qrcode> already emitted <img> or <canvas> inline) */
  private printWithHtmlClone(innerHtml: string) {
    this.createIframeAndPrint(innerHtml);
  }

  /** create an iframe, write html, wait for load, call print, remove iframe */
  private createIframeAndPrint1(bodyHtml: string) {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document;
    if (!doc) {
      console.error('print: cannot access iframe document');
      document.body.removeChild(iframe);
      return;
    }

    // Build a minimal print page. Add any CSS you need here.
    doc.open();
    doc.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          .print-section-block {width: 70%;display:flex;justify-content:space-between; align-items:center;margin 0 auto }
          .print-data p { margin: 4px 0;    margin: 0;
    margin-bottom: 10px;
    font-size: 14px;}
          img { image-rendering: -webkit-optimize-contrast; }
        </style>
      </head>
      <body>${bodyHtml}</body>
    </html>
  `);
    doc.close();

    // Give the iframe a moment to layout images
    const onLoadOrReady = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } catch (err) {
        console.error('print error when calling print()', err);
      } finally {
        setTimeout(() => {
          try { document.body.removeChild(iframe); } catch (e) { }
        }, 500);
      }
    };

    // If iframe has a window, try to wait for load; otherwise fallback after timeout
    if (iframe.contentWindow) {
      // small delay to ensure images are decoded / painted
      setTimeout(onLoadOrReady, 200);
    } else {
      setTimeout(onLoadOrReady, 500);
    }
  }



  private createIframeAndPrint(bodyHtml: string) {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document;
    if (!doc) {
      console.error('print: cannot access iframe document');
      document.body.removeChild(iframe);
      return;
    }

    doc.open();
    doc.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 5px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center; /* center text inside blocks */
            max-height: 60vh; /* full page height */
            margin: 0;
              // background-color: #e8249d57;

          }
          .print-section-block {
            width: 100%;
            display: flex;
            flex-direction: row; /* stack content vertically */
            justify-content: center;
            align-items: center;
            // margin: 0 auto;
            margin-left: auto;
            margin-right: auto;
              // background-color: #47a4dd57;

          }
          .print-data{
            display: flex;
            flex-direction: column; /* stack content vertically */
            justify-content: flex-start;
            align-items: flex-start;
              // background-color: #1a13ea57;
              width: 60%

          }
          .print-data p {
            margin: 0 0 10px 0;
            font-size: 14px;
            text-align: left;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            
          }
          .print-data p:last-child {
            margin: 0;
          }

.print-data p span {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
          img {
            image-rendering: -webkit-optimize-contrast;
            width: 160px;
            height: 160px;
          }
        </style>
      </head>
      <body>${bodyHtml}</body>
    </html>
  `);
    doc.close();

    const onLoadOrReady = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } catch (err) {
        console.error('print error when calling print()', err);
      } finally {
        setTimeout(() => {
          try { document.body.removeChild(iframe); } catch (e) { }
        }, 500);
      }
    };

    if (iframe.contentWindow) {
      setTimeout(onLoadOrReady, 200);
    } else {
      setTimeout(onLoadOrReady, 500);
    }
  }

  editStatusClick() {
    this.isEditStatus = !this.isEditStatus
  }


  // updateObjectHolding(objectInfoId: any) {

  //   const body = {
  //     "objectInfoId": objectInfoId,
  //     "holding": {
  //       "allocationRegisterId": this.singleObjectAllocationRegisterData[0]?.objectAllocationRegisterId,
  //       "userId": Number(sessionStorage.getItem('userId')),
  //       "name": sessionStorage.getItem('userName'),
  //     },
  //     "cid": Number(sessionStorage.getItem('cid')),
  //   }
  //   console.log(body)
  //   this.generic_service.updateObjectHolding(body).subscribe(
  //     (response:any)=> {
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }

  updateObjectCondition() {
    let body: any = {
      "objectInfoId": this.objectInfoId,
      "version": 0,
      "isActive": true,
      "description": "",
      "to": "Faulty",
      "cid": Number(localStorage.getItem('cid')),
    }
    console.log(body)

    this.generic_service.updateObjectCondition(body).subscribe(
      (response: any) => {
        console.log(response)
        // this.updateObjectHolding(this.objectInfoId)
        this.getObjectInfoById(this.objectInfoId)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  updateObjectStatusRequest() {
    let body: any = {
      "objectInfoId": this.objectInfoId,
      "statusDTOForObjectInfo": {
        "userId": this.userCred.userId,
        "issueStatus": "FAULTY",
        "updatedDate": new Date().getTime(),
        "name": this.userCred.userName,
        "remarks": this.objStatus.remarks
      },
      "cid": Number(localStorage.getItem('cid')),
    }
    console.log(body)

    this.generic_service.updateObjectStatusRequest(body).subscribe(
      (response: any) => {
        console.log(response)
        this.updateObjectCondition()
        this.toastr.success(response.message);
        this.isEditStatus = false
        this.objStatus.remarks = ""
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }




  //   async getParent(objectInfoId: number): Promise<void> {
  //   console.log("Fetching all parents for:", objectInfoId);

  //   const parentsObjects: any[] = [];
  //   const visitedIds: Set<number> = new Set();

  //   const fetchRecursive = async (id: number) => {
  //     if (visitedIds.has(id)) return;
  //     visitedIds.add(id);

  //     try {
  //       const response: any = await this.generic_service.getObjectInfoById(id).toPromise();
  //       const data = response?.response;

  //       if (!data || !data.lat || data.lat === 0) return;

  //       parentsObjects.push(data);

  //       if (Array.isArray(data.parentAssetId) && data.parentAssetId.length > 0) {
  //         for (const parentId of data.parentAssetId) {
  //           if (parentId && parentId !== 0) {
  //             await fetchRecursive(parentId);
  //           }
  //         }
  //       }

  //     } catch (error) {
  //       console.error(`Error fetching parent for ID ${id}:`, error);
  //     }
  //   };

  //   // Fetch all parent data
  //   await fetchRecursive(objectInfoId);
  //   console.log("All parents fetched:", parentsObjects);







  // }

  async getParent2(objectInfoId: number): Promise<any[]> {
    console.log("Fetching all parents for:", objectInfoId);

    const parentsObjects: any[] = [];
    const visitedIds: Set<number> = new Set();

    const fetchRecursive = async (id: number): Promise<void> => {
      if (visitedIds.has(id)) return;
      visitedIds.add(id);

      try {
        const response: any = await firstValueFrom(
          this.generic_service.getObjectInfoById(id)
        );

        const data = response?.response;
        if (!data || !data.lat || data.lat === 0) return;

        parentsObjects.push(data);

        if (Array.isArray(data.parentAssetId) && data.parentAssetId.length > 0) {
          await Promise.all(
            data.parentAssetId
              .filter((parentId: number) => parentId && parentId !== 0)
              .map((parentId: number) => fetchRecursive(parentId))
          );
        }

      } catch (error) {
        console.error(`Error fetching parent for ID ${id}:`, error);
      }
    };

    // Start from parents only (not the object itself)
    const initialResponse: any = await firstValueFrom(
      this.generic_service.getObjectInfoById(objectInfoId)
    );

    const initialData = initialResponse?.response;

    if (Array.isArray(initialData?.parentAssetId)) {
      await Promise.all(
        initialData.parentAssetId
          .filter((parentId: number) => parentId && parentId !== 0)
          .map((parentId: number) => fetchRecursive(parentId))
      );
    }

    console.log("All parents fetched:", parentsObjects);
    return parentsObjects;
  }



  async getParent(objectInfoId: number) {

    // Array to store all fetched parent objects
    const parents: any[] = [];

    // Set to keep track of already visited IDs
    // This prevents infinite loops if circular references exist
    const visited = new Set<number>();

    // Recursive function to fetch a parent by ID
    const fetchParent = async (id: number) => {

      // Stop if:
      // - ID is invalid (null, 0, undefined)
      // - ID was already processed
      if (!id || visited.has(id)) return;

      // Mark this ID as visited
      visited.add(id);

      try {
        // Call API to get object info
        const response: any = await firstValueFrom(
          this.generic_service.getObjectInfoById(id)
        );

        // Extract actual data from response
        const data = response?.response;

        // If no data returned, stop here
        if (!data) return;

        // Add this object to parents array
        parents.push(data);

        // If this object has parent IDs
        if (Array.isArray(data.parentAssetId)) {

          // Loop through each parent ID
          for (const parentId of data.parentAssetId) {

            // Recursively fetch each parent
            await fetchParent(parentId);
          }
        }

      } catch (error) {
        // Handle API errors safely
        console.error("Error fetching parent:", error);
      }
    };

    // Start the recursive fetching from the given object ID
    await fetchParent(objectInfoId);

    // Return all collected parent objects
    this.objectInfoList = parents;
  }


  async getChildren(objectInfoId: number) {

    // Array to store all fetched child objects
    const children: any[] = [];

    // Set to prevent infinite loops (in case of circular references)
    const visited = new Set<number>();

    // Recursive function to fetch child by ID
    const fetchChild = async (id: number) => {

      // Stop if:
      // - ID is invalid
      // - ID already processed
      if (!id || visited.has(id)) return;

      // Mark ID as visited
      visited.add(id);

      try {
        // Call API to get object info
        const response: any = await firstValueFrom(
          this.generic_service.getObjectInfoById(id)
        );

        // Extract actual data
        const data = response?.response;

        // Stop if no data found
        if (!data) return;

        // Add current object to children array
        children.push(data);

        // If this object has child IDs
        if (Array.isArray(data.childAssetId)) {

          // Loop through each child ID
          for (const childId of data.childAssetId) {

            // Recursively fetch each child
            await fetchChild(childId);
          }
        }

      } catch (error) {
        // Handle API errors
        console.error("Error fetching child:", error);
      }
    };

    // Start recursion from the given object ID
    await fetchChild(objectInfoId);

    // Return all collected child objects
    this.objectInfoList = children;
  }


  getParentsFromList(objectInfoId: any) {

    const parents: any[] = [];
    const visited = new Set<number>();

    const findParent = (id: number) => {

      if (!id || visited.has(id)) return;
      visited.add(id);

      // Find object from already loaded list
      const obj = this.objectInfoListFilter.find(
        (item: any) => item.objectInfoId == id
      );


      if (!obj) return;

      parents.push(obj);

      if (Array.isArray(obj.parentAssetId)) {
        for (const parentId of obj.parentAssetId) {
          findParent(parentId);
        }
      }
    };

    findParent(objectInfoId);
    this.count = parents.length || 0

    this.objectInfoListWithPagination = parents;

  }


  getChildrenFromList(objectInfoId: any) {

    const children: any[] = [];
    const visited = new Set<number>();

    const findChild = (id: number) => {

      if (!id || visited.has(id)) return;
      visited.add(id);

      // Find object from already loaded list
      const obj = this.objectInfoListFilter.find(
        (item: any) => item.objectInfoId === id
      );

      if (!obj) return;

      children.push(obj);

      if (Array.isArray(obj.childAssetId)) {
        for (const childId of obj.childAssetId) {
          findChild(childId);
        }
      }
    };

    findChild(objectInfoId);
    this.count = children.length || 0
    this.objectInfoList = children;
  }


  assetCondition(condition: any) {
    for (let list of this.assetConditions) {
      if (list.value == condition) {
        return list.label
      }
    }
    return "--"

  }




  nmsSync() {
    this.generic_service.syncPorts(this.singleObjectInfoData[0].objectInfoId).subscribe(
      (response: any) => {
        this.getObjectInfoById(this.singleObjectInfoData[0].objectInfoId)
        // this.loadData()
        this.toastr.success(response.message)
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }


}





